/* 三國逗陣打 · 畫面層：鏡頭、地面區塊快取、依縱深排序的角色與建築、投射物、血條、小地圖 */
// @ts-nocheck — 第 2 步只把檔案改成模組，型別在第 4 步補
import { SG } from '../core/sg.ts';

const M = SG.MAP;
const COL = { ally: '#f0b43c', foe: '#b57cff', neutral: '#d8a05a' };
// 隊伍訊號（ping）：種類、文字、顏色、圖示字
export const PINGS = {
  go: { name: '注意這裡', col: '#ffd46b', ch: '注' },
  attack: { name: '攻擊目標', col: '#ff6a5a', ch: '擊' },
  danger: { name: '危險，撤退', col: '#ff4a3a', ch: '危' },
  gather: { name: '集合', col: '#6fb3ff', ch: '合' },
  miss: { name: '敵人消失', col: '#c9a2ff', ch: '？' },
  otw: { name: '正在前往', col: '#8fe08a', ch: '往' },
};
SG.PINGS = PINGS;
const PING_LIFE = 3.2;
const CH = 512, VIEW_H = 760;

const d2 = (v) => v.dpr || 1;
class View {
  // o.camH：鏡頭高度（顯示多少戰場）；o.noCutin：大招不跳全畫面字卡。練習頁的技能預覽用小畫面拉近、不跳字卡（game.ts）
  constructor(canvas, world, mini, o) {
    this.camH = o && o.camH; this.noCutin = !!(o && o.noCutin);
    this.c = canvas; this.ctx = canvas.getContext('2d'); this.w = world; this.me = world.player; this.team = this.me.team;
    this.actors = new Map(); this.chunks = new Map(); this.props = new Map(); this.nums = [];
    this.cam = { x: this.me.x, y: this.me.y };
    this.WS = { fx: [], parts: [], o: { textTop: -1e9, reach: 1, skip: { bolt: 1, summon: 1, fade: 1, crescent: 1, fire: 1, spikes: 1, thunder: 1, rain: 1, chain: 1, slam: 1, trap: 1, heal: 1, impact: 1, puff: 1 } }, W: M.W, time: 0, shake: 0, timers: [],
      after(t, fn) { this.timers.push({ t, fn }); } };
    this.WS.unitOf = (id) => (this.w.byId ? this.w.byId.get(id) : this.w.units.find((u) => u.id === id)); // 特效事件的施放者（src）→ 單位，造型特效用
    this.mini = mini; this.miniCtx = mini.getContext('2d'); this.miniT = 0;
    this.camLock = true; this.pan = [0, 0]; this.indicator = null; this.hover = null; this.marks = []; this.wps = []; this.aim = null; this.pings = [];
    this.resize();
    window.addEventListener('resize', () => this.resize());
    // 手機進出全螢幕、網址列伸縮時，resize 事件常比版面更新早到：直接看畫布的實際大小，變了就重算（不然畫面會被壓扁）
    if (window.ResizeObserver) new ResizeObserver(() => { if (this.c.clientWidth !== this.cw || this.c.clientHeight !== this.ch) this.resize(); }).observe(this.c);
    document.addEventListener('fullscreenchange', () => requestAnimationFrame(() => this.resize()));
    if (window.visualViewport) window.visualViewport.addEventListener('resize', () => requestAnimationFrame(() => { if (this.c.clientWidth !== this.cw || this.c.clientHeight !== this.ch) this.resize(); }));
    this.keys0 = new Set(Object.keys(this)); this.keys0.add('keys0');
  }
  // 換一個世界繼續用（技能預覽換武將）：之後才長出來的狀態（殘影、印記、公告…）全部丟掉，地面圖塊留著不重畫
  rebind(world) {
    for (const k of Object.keys(this)) if (!this.keys0.has(k)) delete this[k];
    this.w = world; this.me = world.player; this.team = this.me.team;
    this.actors = new Map(); this.props = new Map(); this.nums = []; this.marks = []; this.wps = []; this.pings = [];
    this.indicator = null; this.hover = null; this.aim = null; this.pinned = null; this.miniBase = null;
    this.cam = { x: this.me.x, y: this.me.y };
    Object.assign(this.WS, { fx: [], parts: [], timers: [], time: 0, shake: 0 });
  }
  rel(u) { return u.team === 2 ? 'neutral' : u.team === this.team ? 'ally' : 'foe'; }
  resize() {
    const dpr = Math.min(SG.GFX ? SG.GFX.dpr : 2, window.devicePixelRatio || 1), cw = this.c.clientWidth, ch = this.c.clientHeight; // 解析度上限依畫質（game.ts applyGfx）
    this.c.width = Math.round(cw * dpr); this.c.height = Math.round(ch * dpr);
    this.dpr = dpr; this.cw = cw; this.ch = ch;
    // 鏡頭高度：畫面垂直方向顯示多少戰場。手機橫拿很寬很矮，用桌機的 760 會把戰場攤成扁扁的長條，所以觸控時拉近（SG.CAM_H，game.ts 設定）
    this.zoom = this.baseZoom = Math.max(ch / (this.camH || SG.CAM_H || VIEW_H), cw / 2100);
    this.chunkScale = Math.min(1.5, this.zoom * dpr);
    this.chunks.clear(); this.pinned = null;
    const mw = this.mini.clientWidth || 240;
    this.mini.width = Math.round(mw * dpr); this.mini.height = Math.round(mw * (M.H / M.W) * dpr);
    this.miniBase = null;
  }

  chunk(cx, cy) {
    const key = cx + ',' + cy;
    let c = this.chunks.get(key);
    if (c) { this.chunks.delete(key); this.chunks.set(key, c); return c; }
    c = document.createElement('canvas');
    const px = Math.ceil((CH + 2) * this.chunkScale);
    c.width = px; c.height = px;
    const x = c.getContext('2d');
    x.setTransform(this.chunkScale, 0, 0, this.chunkScale, -cx * CH * this.chunkScale, -cy * CH * this.chunkScale);
    M.paint(x, cx * CH, cy * CH, CH + 2, CH + 2);
    this.chunks.set(key, c);
    // 超過上限就丟掉最久沒用的；本營附近的區塊固定留著（回城、復活都落在那裡）
    if (this.chunks.size > 48) for (const k of this.chunks.keys()) { if (!this.pinned || !this.pinned.has(k)) { this.chunks.delete(k); break; } }
    return c;
  }
  // 預先畫地面：每幀最多補畫一塊，順序是畫面外圍一圈、再來是我方本營（畫面內缺的區塊照常當幀畫）
  prewarm(x0, y0, vw, vh) {
    if (!this.pinned) {
      const b = M.bases[this.team], r = 700;
      this.pinned = new Set();
      for (let cx = Math.floor((b.x - r) / CH); cx <= Math.floor((b.x + r) / CH); cx++) for (let cy = Math.floor((b.y - r) / CH); cy <= Math.floor((b.y + r) / CH); cy++) if (cx >= 0 && cy >= 0) this.pinned.add(cx + ',' + cy);
    }
    const want = [];
    for (let cx = Math.floor((x0 - CH) / CH); cx <= Math.floor((x0 + vw + CH) / CH); cx++) for (let cy = Math.floor((y0 - CH) / CH); cy <= Math.floor((y0 + vh + CH) / CH); cy++) want.push(cx + ',' + cy);
    for (const k of this.pinned) want.push(k);
    for (const k of want) {
      const [cx, cy] = k.split(',').map(Number);
      if (cx < 0 || cy < 0 || cx * CH > M.W || cy * CH > M.H || this.chunks.has(k)) continue;
      this.chunk(cx, cy);
      return;
    }
  }

  actorFor(u) {
    let a = this.actors.get(u.id);
    if (!a) {
      const s = u.kind === 'minion' ? 0.74 : u.kind === 'creep' ? (u.spec === SG.NEUTRAL.bandit ? 0.95 : 0.8) : 1;
      a = new SG.Actor(u.spec, u.x, u.y, u.f, s, {});
      a.stage = this.WS; a.seq = -1;
      if (u.kind === 'hero' || u.kind === 'boss') {
        const r = this.rel(u);
        a.ring = u.isPlayer ? '#ffffff' : COL[r]; a.dash = r === 'foe';
      }
      this.actors.set(u.id, a);
    }
    if (a.spec !== u.spec && u.spec && u.spec.forms) a.setSpec(u.spec); // 形態切換（v0.5.0）：兵器、動作跟著換
    return a;
  }
  propFor(u) {
    let p = this.props.get(u.id);
    if (!p) {
      const flags = u.team === 0 ? [{ x: -14, col: '#3f8a55', ch: '劉' }, { x: 16, col: '#b8392f', ch: '孫' }] : [{ x: 2, col: '#35518c', ch: '曹' }];
      const bf = u.team === 0 ? [{ x: -30, col: '#3f8a55', ch: '漢' }, { x: 0, col: '#b8392f', ch: '吳' }, { x: 30, col: '#8a6a2a', ch: '盟' }] : [{ x: -20, col: '#35518c', ch: '魏' }, { x: 20, col: '#26335f', ch: '曹' }];
      p = u.kind === 'barracks' || u.kind === 'granary' ? SG.tower(u.x, u.y, 0.8, [{ x: 2, col: u.kind === 'granary' ? '#8a5a1e' : u.team === 0 ? '#8a6a2a' : '#26335f', ch: u.kind === 'granary' ? '糧' : '營' }], u.team) : SG.tower(u.x, u.y, u.kind === 'base' ? 1.6 : 1.05, u.kind === 'base' ? bf : flags, u.team);
      this.props.set(u.id, p);
    }
    return p;
  }

  frame(dt) {
    const w = this.w, ctx = this.ctx, WS = this.WS;
    WS.time += dt;
    WS.timers = WS.timers.filter((t) => { t.t -= dt; if (t.t <= 0) { t.fn(); return false; } return true; });
    for (const o of w.vfx) {
      if (o.k === 'ult') { this.startCutin(o); this.ultOn(o); }
      else if (o.k === 'herokill' || o.k === 'basefall' || o.k === 'levelup') { this.juiceOn(o); continue; }
      else { SG.fxAt(WS, o); this.decalOn(o); }
      if (SG.Audio) SG.Audio.vfx(o, this);
    }
    w.vfx.length = 0;
    SG.updateFx(WS, dt);
    WS.shake = WS.shake > 0.2 ? WS.shake * Math.pow(0.002, dt) : 0;
    // 瞄準長射程技能（手機，SG.aimRange）：鏡頭自動拉遠到看得見整個施放範圍，放開再慢慢回來（v0.3.4）
    if (this.baseZoom) {
      const R = SG.aimRange || 0, fit = R ? Math.min(this.cw / (2 * R + 260), this.ch / (2 * R * SG.K + 260)) : Infinity;
      const target = Math.min(this.baseZoom, Math.max(this.baseZoom * 0.4, fit));
      if (Math.abs(target - this.zoom) > 1e-4) this.zoom += (target - this.zoom) * Math.min(1, dt * 7);
    }
    // 鏡頭
    const me = this.me, vw = this.cw / this.zoom, vh = this.ch / this.zoom;
    if (this.focus) {
      // 本營倒下：鏡頭拉過去看它崩塌
      this.focus.t -= dt;
      this.cam.x += (this.focus.x - this.cam.x) * Math.min(1, dt * 3); this.cam.y += (this.focus.y - 60 - this.cam.y) * Math.min(1, dt * 3);
      if (this.focus.t <= 0) this.focus = null;
    } else if (this.camLock || this.camHold) {
      // 按住空白：幾乎立刻對準武將
      const tx = me.alive ? me.x : M.bases[me.team].x, ty = me.alive ? me.y - 40 : M.bases[me.team].y;
      const k = this.camHold ? Math.min(1, dt * 25) : me.alive ? Math.min(1, dt * 8) : Math.min(1, dt * 2);
      this.cam.x += (tx - this.cam.x) * k; this.cam.y += (ty - this.cam.y) * k;
    } else { this.cam.x += this.pan[0] * 1400 * dt; this.cam.y += this.pan[1] * 1400 * dt; }
    this.cam.x = Math.max(vw / 2, Math.min(M.W - vw / 2, this.cam.x));
    this.cam.y = Math.max(vh / 2 + 120, Math.min(M.H - vh / 2 + 40, this.cam.y));
    const x0 = this.cam.x - vw / 2, y0 = this.cam.y - vh / 2;
    this.vp = { x0, y0, vw, vh };
    this.view = [x0, y0, vw, vh];
    const s = this.zoom * this.dpr;
    const sx = WS.shake ? (Math.random() - 0.5) * WS.shake : 0, sy = WS.shake ? (Math.random() - 0.5) * WS.shake : 0;
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.fillStyle = '#1b2016'; ctx.fillRect(0, 0, this.c.width, this.c.height);
    ctx.setTransform(s, 0, 0, s, (-x0 + sx) * s, (-y0 + sy) * s);
    for (let cx = Math.floor(x0 / CH); cx <= Math.floor((x0 + vw) / CH); cx++) {
      for (let cy = Math.floor(y0 / CH); cy <= Math.floor((y0 + vh) / CH); cy++) {
        if (cx < 0 || cy < 0 || cx * CH > M.W || cy * CH > M.H) continue;
        ctx.drawImage(this.chunk(cx, cy), cx * CH, cy * CH, CH + 2, CH + 2);
      }
    }
    this.prewarm(x0, y0, vw, vh);
    const inView = (x, y, m) => x > x0 - m && x < x0 + vw + m && y > y0 - m && y < y0 + vh + m + 120;
    this.drawWater(ctx, x0, y0, vw, vh);
    this.drawZones(ctx, inView);
    this.drawMarks(ctx, dt);
    this.drawPings(ctx, dt);
    this.drawDecals(ctx, dt);
    const CD = w.campaign && w.campaign.mission ? SG.campaignDraw : null; // 列傳：蹄印、驄馬、任務標記
    if (CD) CD.ground(ctx, this, inView);
    this.drawIndicator(ctx);
    SG.drawFx(ctx, WS, true);

    // 依縱深排序的實體
    const ents = [];
    for (const z of this.funnels || []) ents.push({ y: this.funnelPos(z)[1], draw: () => this.drawFunnel(ctx, z) });
    this.funnels = [];
    for (const u of w.units) {
      if (u.kind === 'ward') {
        if (u.owl) { if (u.alive && inView(u.x, u.y, 200) && (u.team === this.team || u.vis[this.team])) ents.push({ y: u.y + 400, draw: () => this.drawOwl(ctx, u) }); continue; }
        if (u.alive && u.team === this.team && inView(u.x, u.y, 60)) ents.push({ y: u.y, draw: () => this.drawWard(ctx, u) });
        continue;
      }
      if (u.beast) {
        if (!u.alive || !inView(u.x, u.y, 200) || (u.team !== this.team && !u.vis[this.team])) continue;
        const B = { water: () => this.drawWaterSpirit(ctx, u), waterking: () => this.drawWaterSpirit(ctx, u, true), elephant: () => this.drawElephant(ctx, u), spirit: () => this.drawSpirit(ctx, u), zombie: () => this.drawZombie(ctx, u), golem: () => this.drawGolem(ctx, u), snake: () => this.drawSnakeWard(ctx, u), tower: () => this.drawArrowTower(ctx, u), hubao: () => this.drawHubao(ctx, u), treant: () => this.drawTreant(ctx, u) };
        const draw = B[u.beast] || (() => this.drawTiger(ctx, u));
        ents.push({ y: u.y, draw, u });
        continue;
      }
      if (u.structure) {
        if (!inView(u.x, u.y, 300) || u.gone) continue;
        const p = this.propFor(u);
        ents.push({ y: u.y, draw: u.alive ? () => p.draw(ctx, WS.time * 1000) : () => this.drawRuin(ctx, u) });
        continue;
      }
      if (u.kind === 'seal') { // 玉璽（圖案由 w.seal 畫）：上方 5 格血，顏色是正在打的那一隊
        if (u.alive && inView(u.x, u.y, 120)) ents.push({ y: u.y + 1, draw: () => this.drawSealPips(ctx, u, w.seal.team) });
        continue;
      }
      if (u.kind === 'cart') {
        if (!u.alive || !inView(u.x, u.y, 200)) continue;
        ents.push({ y: u.y, draw: () => this.drawCart(ctx, u), u });
        continue;
      }
      if (u.siege) {
        if (!u.alive || !inView(u.x, u.y, 200) || (u.team !== this.team && !u.vis[this.team])) continue;
        ents.push({ y: u.y, draw: () => this.drawSiege(ctx, u), u });
        continue;
      }
      const a = this.actorFor(u);
      a.x = u.x; a.y = u.y; a.f = u.f; a.noPx = !!u.noPx;
      if (a.seq !== u.animSeq) {
        const first = a.seq === -1; a.seq = u.animSeq;
        // 放技能時，揮砍特效改用技能元素的顏色
        a.fxEl = SG.elOf && u.spec.skills && /^s\d$/.test(u.anim) ? SG.elOf(u.spec.skills[+u.anim[1]], u.spec.id) : null;
        a.play(u.anim); if (!first && SG.Audio) SG.Audio.anim(u, u.anim, this); }
      else if (u.alive && a.anims[a.cur].loop && a.cur !== u.loop) a.play(u.loop);
      a.update(dt * (u.act && u.act.kind === 'skill' && u.act.fast ? u.act.fast : 1)); // 小技能前搖加快（v0.3.0）：動畫跟著快
      if (!inView(u.x, u.y, 200)) continue;
      let alpha = 1;
      if (!u.alive) { alpha = Math.max(0, 1 - Math.max(0, w.t - u.deadT - 1) / 0.8); if (alpha <= 0) continue; }
      else if (u.team !== this.team && !u.vis[this.team]) continue;
      else if (u.st.invis > 0) alpha = 0.4;
      else if (u.brush >= 0 && u.team === this.team) alpha = 0.7;
      a.alpha = alpha;
      // 受擊：血量掉了就閃白，並在身上爆出一圈打擊火花（大小看這一下佔最大生命多少）
      if (a.lastHp !== undefined && u.hp < a.lastHp - 0.5 && u.alive) {
        a.flash = 0.1;
        const frac = Math.min(1, (a.lastHp - u.hp) / u.maxHp);
        if (alpha > 0.5 && (this.hits = this.hits || []).length < 40) this.hits.push({ x: u.x + (Math.random() - 0.5) * 16, y: u.y - 46 * (u.spec && u.spec.size || 1), t: 0, size: 0.8 + Math.min(1.4, frac * 9), seed: Math.random() * 6 });
      }
      // 陣亡：地上一圈塵土與墨漬；武將另外有幾縷魂魄往上飄
      if (a.wasAlive && !u.alive && alpha > 0.3 && w.t - u.deadT < 0.3) {
        const big = u.kind === 'hero' || u.kind === 'boss';
        (this.decals = this.decals || []).push({ k: 'ink', x: u.x, y: u.y, t: 0, life: big ? 6 : 3, seed: Math.random() * 1000, r: big ? 46 : 26 });
        (this.deaths = this.deaths || []).push({ x: u.x, y: u.y, t: 0, big, col: (u.spec && u.spec.fx) || '#ffffff' });
      }
      a.wasAlive = u.alive;
      a.lastHp = u.hp; if (a.flash > 0) a.flash -= dt;
      // 奔跑揚塵：每隔一段腳步在腳後跟揚起一小團塵土（水裡不揚塵）
      if (u.alive && (u.loop === 'run' || u.loop === 'walk') && u.kind !== 'minion' && alpha > 0.5 && Math.abs(M.riverDist(u.x, u.y)) > M.river.hw) {
        a.dustT = (a.dustT || 0) - dt;
        if (a.dustT <= 0) { a.dustT = u.loop === 'run' ? 0.22 : 0.38; (this.dust = this.dust || []).push({ x: u.x - u.f * 12 + (Math.random() - 0.5) * 8, y: u.y + 2, t: 0, s: 0.7 + Math.random() * 0.5, vx: -u.f * 18 }); if (this.dust.length > 80) this.dust.shift(); }
      }
      if (SG.elUnit && u.alive && alpha > 0.5) SG.elUnit(WS, u, dt, w);
      if (SG.legendUnit && u.spec && u.spec.legend && alpha > 0.5) SG.legendUnit(WS, u, dt, a, w);
      if (u === this.hover) ents.push({ y: u.y - 0.01, draw: () => this.drawHover(ctx, u) });
      ents.push({ y: u.y, draw: () => { if (u.spec.aura && u.alive) this.drawAura(ctx, u); a.draw(ctx, WS.time * 1000); if (u.st.freeze > 0) { this.drawIce(ctx, u); if (SG.legendIce) SG.legendIce(ctx, u, WS); } if (SG.legendOver && u.spec.legend) SG.legendOver(ctx, u, WS, this); }, u });
    }
    const [gx0, gy0] = [x0 - 120, y0 - 40];
    for (const t of M.trees) {
      if (!(t.x > gx0 && t.x < x0 + vw + 120 && t.y > gy0 && t.y < y0 + vh + 160)) continue;
      // 武將走到樹後面時，樹變半透明
      const hide = me.alive && Math.abs(me.x - t.x) < 70 * t.s && t.y > me.y && t.y - me.y < 140 * t.s;
      ents.push({ y: t.y, draw: () => M.drawTree(ctx, t, hide ? 0.4 : 1) });
    }
    for (const c of M.camps) if (inView(c.x, c.y, 200)) ents.push({ y: c.y - 40, draw: () => M.drawCamp(ctx, c) });
    const seal = w.seal;
    if (seal.state === 'ground' && inView(seal.x, seal.y, 80)) ents.push({ y: seal.y, draw: () => this.drawSeal(ctx, seal.x, seal.y - 30 - Math.sin(WS.time * 3) * 6, 1.2, true) });
    if (seal.state === 'held' && seal.holder.alive) { const h = seal.holder; ents.push({ y: h.y + 0.02, draw: () => this.drawSeal(ctx, h.x, h.y - 150 * ((h.spec && h.spec.size) || 1), 0.7, false) }); }
    if (CD) CD.ents(ctx, this, ents, inView);
    ents.sort((a, b) => a.y - b.y);
    for (const e of ents) e.draw();

    this.drawProjs(ctx, inView);
    SG.drawFx(ctx, WS, false);
    SG.drawParts(ctx, WS);
    this.drawJuiceWorld(ctx, dt);
    if (SG.drawClouds) SG.drawClouds(ctx, this, x0, y0, vw, vh);
    if (SG.drawGlow) SG.drawGlow(ctx, this, inView);
    if (SG.ambient && dt > 0) SG.ambient(this, dt, x0, y0, vw, vh);
    for (const e of ents) if (e.u && e.u.alive) { this.drawBar(ctx, e.u); if (SG.drawMark) SG.drawMark(ctx, e.u, WS.time); if (SG.drawRecall && e.u.recall) SG.drawRecall(ctx, e.u); }
    this.drawFog(ctx, x0, y0, vw, vh);
    this.drawLight(ctx, x0, y0, vw, vh);
    if (CD) CD.over(ctx, this, x0, y0, vw, vh);
    if (w.wind.on > 0) this.drawWind(ctx, dt);
    for (const u of w.units) if (u.structure && u.alive && inView(u.x, u.y, 300)) this.drawBar(ctx, u);
    this.drawNums(ctx, dt);
    this.drawCutin(dt);
    this.drawJuiceScreen(dt);
    this.miniT -= dt;
    if (this.miniT <= 0) { this.miniT = 0.15; this.drawMini(); }
  }

  // 龐統「龍捲風」：地上一圈旋轉的風痕與塵土，中間一根會左右游移的漏斗雲，碎石、落葉繞著轉
  drawTornado(ctx, z) {
    const T = this.WS.time, seed = (z.x * 7 + z.y * 13) % 100, K = SG.K, R = z.r;
    const ally = z.team === this.team;
    ctx.save(); ctx.translate(z.x, z.y);
    // 範圍：淡淡的地面陰影＋旋轉的弧形風痕
    const g = ctx.createRadialGradient(0, 0, 0, 0, 0, R); g.addColorStop(0, 'rgba(70,80,95,.32)'); g.addColorStop(0.7, 'rgba(90,100,115,.16)'); g.addColorStop(1, 'rgba(90,100,115,0)');
    ctx.fillStyle = g; ctx.beginPath(); ctx.ellipse(0, 0, R, R * K, 0, 0, Math.PI * 2); ctx.fill();
    ctx.strokeStyle = ally ? 'rgba(240,200,120,.5)' : 'rgba(200,170,255,.5)'; ctx.lineWidth = 1.5; ctx.setLineDash([5, 8]);
    ctx.beginPath(); ctx.ellipse(0, 0, R, R * K, 0, 0, Math.PI * 2); ctx.stroke(); ctx.setLineDash([]);
    ctx.lineCap = 'round';
    for (let i = 0; i < 10; i++) {
      const rr = R * (0.3 + (i % 5) * 0.15), a0 = -T * (2.6 - (i % 5) * 0.3) + i * 1.9 + seed;
      ctx.strokeStyle = `rgba(225,232,240,${0.18 + (i % 3) * 0.08})`; ctx.lineWidth = 2 + (i % 3);
      ctx.beginPath(); ctx.ellipse(0, 0, rr, rr * K, 0, a0, a0 + 0.9 + (i % 4) * 0.25); ctx.stroke();
    }
    ctx.restore();
  }
  // 漏斗雲：底部窄、頂部寬，整根繞著中心游移、往同一個方向扭（跟單位一起依縱深排序）
  funnelPos(z) { const T = this.WS.time, seed = (z.x * 7 + z.y * 13) % 100; return [z.x + Math.sin(T * 0.7 + seed) * z.r * 0.28, z.y + Math.cos(T * 0.53 + seed) * z.r * 0.18 * SG.K]; }
  drawFunnel(ctx, z) {
    const T = this.WS.time, seed = (z.x * 7 + z.y * 13) % 100, H = 270, [fx, fy] = this.funnelPos(z);
    ctx.save(); ctx.translate(fx, fy);
    ctx.fillStyle = 'rgba(40,45,55,.25)'; ctx.beginPath(); ctx.ellipse(0, 0, 70, 22, 0, 0, Math.PI * 2); ctx.fill(); // 腳下的影子
    const N = 22;
    for (let i = N; i >= 0; i--) {
      const q = i / N, y = -q * H, w = 22 + Math.pow(q, 1.5) * 115, bend = Math.sin(T * 1.8 + q * 3 + seed) * 22 * q;
      const a = 0.55 + 0.3 * (1 - q), shade = 95 + Math.round(q * 75);
      ctx.fillStyle = `rgba(${shade},${shade + 8},${shade + 22},${a})`;
      ctx.beginPath(); ctx.ellipse(bend, y, w, w * 0.22 + 3, 0, 0, Math.PI * 2); ctx.fill();
      ctx.strokeStyle = 'rgba(30,34,44,.35)'; ctx.lineWidth = 1.2; ctx.stroke();
      // 每一圈上的旋轉亮紋
      const ph = T * 7 + q * 9;
      ctx.strokeStyle = `rgba(245,248,252,${0.25 + 0.25 * (1 - q)})`; ctx.lineWidth = 1.6;
      ctx.beginPath(); ctx.ellipse(bend, y, w * 0.92, (w * 0.22 + 3) * 0.92, 0, ph % (Math.PI * 2), (ph % (Math.PI * 2)) + 1.3); ctx.stroke();
    }
    // 頂上的雲帽
    ctx.fillStyle = 'rgba(88,94,108,.6)';
    for (let k = 0; k < 6; k++) { const a = T * 0.6 + k * 1.05, cx = Math.cos(a) * 110 + Math.sin(T * 1.8 + seed) * 22, cy = -H - 6 + Math.sin(a) * 18; ctx.beginPath(); ctx.ellipse(cx, cy, 70, 26, 0, 0, Math.PI * 2); ctx.fill(); }
    // 被捲起來的碎石、落葉、塵土
    for (let k = 0; k < 16; k++) {
      const q = ((T * 0.35 + k / 16 + seed * 0.01) % 1), y = -q * H * 0.95, a = T * (6 - q * 2) + k * 2.3, w = 30 + Math.pow(q, 1.6) * 120;
      const x = Math.cos(a) * w + Math.sin(T * 1.8 + q * 3 + seed) * 22 * q, yy = y + Math.sin(a) * (w * 0.22);
      if (Math.sin(a) < -0.2) continue; // 轉到漏斗後面的先不畫（被擋住）
      ctx.save(); ctx.translate(x, yy); ctx.rotate(T * 8 + k);
      if (k % 3 === 0) { ctx.fillStyle = '#6a8a3a'; ctx.beginPath(); ctx.ellipse(0, 0, 5, 2.4, 0, 0, Math.PI * 2); ctx.fill(); }
      else if (k % 3 === 1) { ctx.fillStyle = '#7a7268'; ctx.fillRect(-3, -3, 6, 6); }
      else { ctx.fillStyle = 'rgba(190,175,150,.7)'; ctx.beginPath(); ctx.arc(0, 0, 4, 0, Math.PI * 2); ctx.fill(); }
      ctx.restore();
    }
    ctx.restore();
  }
  drawZones(ctx, inView) {
    for (const z of this.w.zones) {
      if (z.x2 && z.x2.mine && z.team !== this.team) continue; // 敵方的地雷、結界看不到
      if (z.look === 'tornado') { if (inView(z.x, z.y, z.r + 200)) { this.drawTornado(ctx, z); if (SG.legendZone) SG.legendZone(ctx, z, this.WS); (this.funnels = this.funnels || []).push(z); } continue; }
      if (z.look === 'water' || z.look === 'tide' || z.look === 'deep') { // 技能鋪的水域（凌統旋風棍、孫權）：一窪淺水，水紋慢慢漂，快消失時淡出；潮汐領域外圈多一道湧動的浪
        if (!inView(z.x, z.y, z.r + 40)) continue;
        const T = this.WS.time, ry = z.r * SG.K, al = z.t != null ? Math.min(1, z.t / 0.8) : 1;
        ctx.save(); ctx.globalAlpha = al;
        ctx.fillStyle = 'rgba(93,122,128,.55)'; ctx.beginPath(); ctx.ellipse(z.x, z.y, z.r, ry, 0, 0, Math.PI * 2); ctx.fill();
        ctx.fillStyle = 'rgba(63,97,115,.55)'; ctx.beginPath(); ctx.ellipse(z.x, z.y, z.r * 0.6, ry * 0.6, 0, 0, Math.PI * 2); ctx.fill();
        ctx.strokeStyle = 'rgba(215,235,245,.4)'; ctx.lineWidth = 2; ctx.lineCap = 'round';
        for (let i = 0; i < 6; i++) { const a = i * 1.05 + T * 0.4, d = 0.3 + 0.12 * (i % 3), px = z.x + Math.cos(a) * z.r * d, py = z.y + Math.sin(a) * ry * d; ctx.beginPath(); ctx.moveTo(px, py); ctx.lineTo(px + 14, py + 5); ctx.stroke(); }
        if (z.look === 'deep') { ctx.fillStyle = 'rgba(30,62,84,.75)'; ctx.beginPath(); ctx.ellipse(z.x, z.y, z.r, ry, 0, 0, Math.PI * 2); ctx.fill(); } // 孫權長江天塹的深水
        if (z.look === 'tide') { const k = 0.82 + 0.12 * Math.sin(T * 3); ctx.strokeStyle = 'rgba(160,215,240,.6)'; ctx.lineWidth = 4; ctx.beginPath(); ctx.ellipse(z.x, z.y, z.r * k, ry * k, 0, 0, Math.PI * 2); ctx.stroke(); }
        ctx.restore(); continue;
      }
      if (SG.drawElZone && inView(z.x, z.y, 200) && SG.drawElZone(ctx, z, this.WS.time, this.WS)) continue;
      if (!inView(z.x, z.y, 120) || (!z.ground && !z.root)) continue;
      z.rx = z.r; z.ry = z.r * SG.K;
      const col = z.team === this.team ? 'rgba(240,180,60,' : 'rgba(181,124,255,';
      ctx.save();
      ctx.strokeStyle = col + '.7)'; ctx.fillStyle = col + '.1)'; ctx.lineWidth = 2; ctx.setLineDash([6, 6]);
      ctx.beginPath(); ctx.ellipse(z.x, z.y, z.rx, z.ry, 0, 0, Math.PI * 2); ctx.fill(); ctx.stroke(); ctx.setLineDash([]);
      if (z.dmg && !z.root) { ctx.translate(z.x, z.y); SG.FX.fire(ctx, { pal: z.pal || (z.fire ? 'fire' : z.slow ? 'ice' : 'poison'), small: 1, seed: z.x % 7, s: 1 }, 0.4, this.WS.time); }
      else {
        ctx.fillStyle = '#9aa1a8'; ctx.strokeStyle = SG.INK; ctx.lineWidth = 1;
        for (let i = 0; i < 7; i++) { const a = i * 0.9, px = z.x + Math.cos(a) * z.rx * 0.6, py = z.y + Math.sin(a) * z.ry * 0.6; ctx.beginPath(); ctx.moveTo(px - 4, py + 2); ctx.lineTo(px, py - 5); ctx.lineTo(px + 4, py + 2); ctx.closePath(); ctx.fill(); ctx.stroke(); }
      }
      ctx.restore();
    }
  }
  toWorld(cx, cy) { const [x0, y0] = this.view || [0, 0]; return [x0 + cx / this.zoom, y0 + cy / this.zoom]; }
  // 游標下的單位：以角色身體的矩形判斷（腳底往上約 110）
  pick(wx, wy) {
    let best = null, bd = 1e9;
    for (const u of this.w.units) {
      if (!u.alive || u.kind === 'ward' || u === this.me) continue;
      if (u.team !== this.team && !u.vis[this.team]) continue;
      const s = u.structure ? 1.3 : u.kind === 'minion' ? 0.74 : (u.spec && u.spec.size) || 1, h = u.kind === 'base' ? 260 : u.structure ? 200 : 105 * s, hw = u.structure ? u.r : 26 * s;
      if (Math.abs(wx - u.x) < hw && wy < u.y + 14 && wy > u.y - h) { const d = Math.abs(wy - u.y) + Math.abs(wx - u.x); if (d < bd) { bd = d; best = u; } }
    }
    return best;
  }
  // 衝車與投石車
  drawSiege(ctx, u) {
    const { caps, poly, dot, ink } = SG.draw, T = this.WS.time, col = u.team === 0 ? '#c9a24e' : '#6a7ad8';
    ctx.save(); ctx.translate(u.x, u.y); ctx.scale(u.f, 1);
    ctx.fillStyle = 'rgba(8,6,4,.35)'; ctx.beginPath(); ctx.ellipse(0, 0, 50, 12, 0, 0, Math.PI * 2); ctx.fill();
    poly(ctx, [[-38, -18], [38, -18], [38, -30], [-38, -30]], '#6b4a2e');
    if (u.siege === 'ram') {
      poly(ctx, [[-34, -30], [-20, -64], [24, -64], [34, -30]], '#7a5436');
      caps(ctx, [[[-30, -44], [56, -44], 7, '#4e3421'], [[52, -44], [62, -44], 8, '#8e979f']]);
    } else {
      const sw = u.act && u.act.kind === 'attack' ? -1.1 + (u.act.t / u.act.dur) * 1.6 : -1.1;
      caps(ctx, [[[-6, -30], [-6, -60], 5, '#4e3421'], [[-6, -58], [-6 + Math.cos(sw) * 52, -58 + Math.sin(sw) * 52, ], 4, '#7a5436']]);
      dot(ctx, -6 + Math.cos(sw) * 52, -58 + Math.sin(sw) * 52, 8, '#8a8478', 2);
    }
    const wr = T * 3;
    [-24, 22].forEach((x) => { dot(ctx, x, -10, 11, '#5b3d27', 2); ctx.strokeStyle = SG.INK; ctx.lineWidth = 1.4; for (let i = 0; i < 3; i++) { const a = wr + (i * Math.PI) / 3; SG.draw.line(ctx, [x - Math.cos(a) * 10, -10 - Math.sin(a) * 10], [x + Math.cos(a) * 10, -10 + Math.sin(a) * 10]); } });
    caps(ctx, [[[-38, -30], [-38, -78], 2.2, '#3a2a20']]);
    ctx.beginPath(); ctx.moveTo(-38, -78); ctx.lineTo(-62, -74); ctx.lineTo(-38, -62); ctx.closePath(); ink(ctx, col, 1.6);
    ctx.restore();
  }
  // 水面：沿著江流方向漂動的亮紋
  drawWater(ctx, x0, y0, vw, vh) {
    if (!SG.SHADE) return;
    if (M.drawWater) return M.drawWater(ctx, x0, y0, vw, vh, this.WS.time); // 列傳地圖自己畫（彎曲的河）
    const R = M.river, dx = R.b[0] - R.a[0], dy = R.b[1] - R.a[1], L = Math.hypot(dx, dy), ux = dx / L, uy = dy / L, nx = -uy, ny = ux;
    // 只有畫面有碰到江才畫
    const corners = [[x0, y0], [x0 + vw, y0], [x0, y0 + vh], [x0 + vw, y0 + vh]].map((p) => M.riverDist(p[0], p[1]));
    if (Math.min(...corners) > R.hw + 40 || Math.max(...corners) < -R.hw - 40) return;
    const T = this.WS.time, cx = x0 + vw / 2, cy = y0 + vh / 2;
    const s0 = (cx - R.a[0]) * ux + (cy - R.a[1]) * uy;
    ctx.save(); ctx.lineCap = 'round';
    for (let i = 0; i < 46; i++) {
      const seed = i * 97.31, lane = ((seed * 7.7) % (R.hw * 1.7)) - R.hw * 0.85;
      const s = s0 - vw + ((seed * 3.1 + T * (35 + (i % 5) * 9)) % (vw * 2));
      const px = R.a[0] + ux * s + nx * lane, py = R.a[1] + uy * s + ny * lane;
      const len = 18 + (i % 4) * 9, a = 0.18 + 0.14 * Math.sin(T * 2 + i);
      ctx.strokeStyle = `rgba(215,235,245,${a})`; ctx.lineWidth = 2;
      ctx.beginPath(); ctx.moveTo(px, py); ctx.lineTo(px + ux * len, py + uy * len); ctx.stroke();
    }
    ctx.restore();
  }
  // 光線：暖色的斜射光加暗角，讓平塗的地面有層次
  drawLight(ctx, x0, y0, vw, vh) {
    if (!SG.SHADE) return;
    // 太陽在左上：整個畫面左上偏暖亮、右下偏冷暗，跟地形與影子同一個方向
    const sun = ctx.createLinearGradient(x0, y0, x0 + vw, y0 + vh);
    sun.addColorStop(0, 'rgba(255,232,180,.10)'); sun.addColorStop(0.5, 'rgba(255,232,180,0)'); sun.addColorStop(1, 'rgba(20,34,60,.12)');
    ctx.fillStyle = sun; ctx.fillRect(x0, y0, vw, vh);
    const g = ctx.createRadialGradient(x0 + vw * 0.5, y0 + vh * 0.42, vh * 0.25, x0 + vw * 0.5, y0 + vh * 0.5, vh * 0.95);
    g.addColorStop(0, 'rgba(255,236,190,.07)'); g.addColorStop(0.6, 'rgba(0,0,0,0)'); g.addColorStop(1, 'rgba(8,10,6,.34)');
    ctx.fillStyle = g; ctx.fillRect(x0, y0, vw, vh);
  }
  // 戰爭迷霧：整個畫面蓋一層暗色，再把我方單位的視野挖亮
  drawFog(ctx, x0, y0, vw, vh) {
    if (this.w.spectator) return; // 觀戰：兩邊都看得到
    const q = 6, W = Math.ceil(vw / q), H = Math.ceil(vh / q);
    if (!this.fogC) this.fogC = document.createElement('canvas');
    const c = this.fogC;
    if (c.width !== W || c.height !== H) { c.width = W; c.height = H; }
    const f = c.getContext('2d');
    f.globalCompositeOperation = 'source-over'; f.clearRect(0, 0, W, H);
    f.fillStyle = 'rgba(6,9,8,.58)'; f.fillRect(0, 0, W, H);
    const sh = this.shroudOf(); // 列傳：沒探索過的地方幾乎全黑
    if (sh) { const fq = sh.F.q; f.globalAlpha = 0.92; f.imageSmoothingEnabled = true; f.drawImage(sh.c, x0 / fq, y0 / fq, vw / fq, vh / fq, 0, 0, vw / q, vh / q); f.globalAlpha = 1; }
    f.globalCompositeOperation = 'destination-out';
    for (const u of this.w.units) {
      if (!u.alive || u.team !== this.team) continue;
      const s = SG.sightOf(u);
      if (u.x < x0 - s || u.x > x0 + vw + s || u.y < y0 - s || u.y > y0 + vh + s) continue;
      f.save(); f.translate((u.x - x0) / q, (u.y - y0) / q); f.scale(1, SG.K);
      const g = f.createRadialGradient(0, 0, (s / q) * 0.72, 0, 0, s / q);
      g.addColorStop(0, 'rgba(0,0,0,1)'); g.addColorStop(1, 'rgba(0,0,0,0)');
      f.fillStyle = g; f.beginPath(); f.arc(0, 0, s / q, 0, Math.PI * 2); f.fill(); f.restore();
    }
    ctx.drawImage(c, x0, y0, W * q, H * q);
  }
  // 列傳的探索紀錄畫成一張每格一像素的遮罩（同隊共用；有新格子看過才重畫）
  shroudOf() {
    const F = this.w.campaign && this.w.campaign.fog;
    if (!F || this.w.spectator) return null;
    if (!this.shroud || this.shroud.F !== F) {
      const c = document.createElement('canvas'); c.width = F.cols; c.height = F.rows;
      this.shroud = { F, c, v: -1, img: c.getContext('2d').createImageData(F.cols, F.rows) };
    }
    const sh = this.shroud, S = F.seen[this.team];
    if (sh.v !== F.ver[this.team]) {
      sh.v = F.ver[this.team];
      const d = sh.img.data;
      for (let k = 0; k < S.length; k++) { d[k * 4] = 4; d[k * 4 + 1] = 6; d[k * 4 + 2] = 5; d[k * 4 + 3] = S[k] ? 0 : 255; }
      sh.c.getContext('2d').putImageData(sh.img, 0, 0);
    }
    return sh;
  }
  drawCart(ctx, u) {
    const { caps, poly, dot, ink } = SG.draw, T = this.WS.time;
    ctx.save(); ctx.translate(u.x, u.y); ctx.scale(u.f, 1);
    ctx.fillStyle = 'rgba(8,6,4,.35)'; ctx.beginPath(); ctx.ellipse(0, 0, 58, 12, 0, 0, Math.PI * 2); ctx.fill();
    // 牛
    const step = Math.sin(T * 6) * 3;
    caps(ctx, [[[44, -22], [44 + step, 0], 5, '#5a3e2a'], [[66, -22], [66 - step, 0], 5, '#5a3e2a']]);
    ctx.beginPath(); ctx.ellipse(56, -32, 22, 14, 0, 0, Math.PI * 2); ink(ctx, '#7a5a3e');
    ctx.beginPath(); ctx.ellipse(80, -40, 10, 8, 0.3, 0, Math.PI * 2); ink(ctx, '#7a5a3e');
    caps(ctx, [[[82, -48], [90, -56], 2.4, '#e8e2d0']]);
    caps(ctx, [[[34, -30], [14, -30], 3, '#4e3421']]);
    // 車與糧袋
    poly(ctx, [[-40, -20], [16, -20], [16, -32], [-40, -32]], '#7a5436');
    [[-30, -44], [-12, -46], [6, -44], [-21, -58], [-3, -58]].forEach(([x, y]) => { ctx.beginPath(); ctx.ellipse(x, y, 11, 9, 0, 0, Math.PI * 2); ink(ctx, '#d8c8a0', 1.8); });
    ctx.fillStyle = '#8a2a22'; ctx.font = '900 9px "Noto Serif TC", serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillText('糧', -12, -45);
    const wr = T * 4;
    [-28, 4].forEach((x) => { dot(ctx, x, -10, 11, '#5b3d27', 2); ctx.strokeStyle = SG.INK; ctx.lineWidth = 1.4; for (let i = 0; i < 3; i++) { const a = wr + (i * Math.PI) / 3; SG.draw.line(ctx, [x - Math.cos(a) * 10, -10 - Math.sin(a) * 10], [x + Math.cos(a) * 10, -10 + Math.sin(a) * 10]); } });
    caps(ctx, [[[-40, -32], [-40, -84], 2.2, '#3a2a20']]);
    ctx.beginPath(); ctx.moveTo(-40, -84); ctx.lineTo(-40 - 26, -80 + Math.sin(T * 5) * 2); ctx.lineTo(-40 - 24, -66 + Math.sin(T * 5 + 1) * 2); ctx.lineTo(-40, -66); ctx.closePath();
    ink(ctx, u.team === this.team ? '#c9a24e' : '#8a6ad8', 1.6);
    ctx.restore();
  }
  drawSealPips(ctx, u, team) {
    const n = u.maxHp || 5, w = 14, gap = 4, x0 = u.x - (n * w + (n - 1) * gap) / 2, y = u.y - 92;
    const col = team < 0 ? '#ffe28a' : team === this.team ? '#6fb3ff' : '#ff6a5a';
    for (let i = 0; i < n; i++) {
      ctx.fillStyle = 'rgba(10,12,18,.75)'; ctx.fillRect(x0 + i * (w + gap) - 1, y - 1, w + 2, 9);
      ctx.fillStyle = i < u.hp ? col : 'rgba(255,255,255,.12)'; ctx.fillRect(x0 + i * (w + gap), y, w, 7);
    }
  }
  drawSeal(ctx, x, y, s, glow) {
    ctx.save(); ctx.translate(x, y); ctx.scale(s, s);
    if (glow) {
      const g = ctx.createRadialGradient(0, 0, 0, 0, 0, 60); g.addColorStop(0, 'rgba(160,255,200,.55)'); g.addColorStop(1, 'rgba(160,255,200,0)');
      ctx.fillStyle = g; ctx.fillRect(-60, -60, 120, 120);
      ctx.fillStyle = 'rgba(8,6,4,.3)'; ctx.beginPath(); ctx.ellipse(0, 36, 20, 6, 0, 0, Math.PI * 2); ctx.fill();
    }
    SG.draw.poly(ctx, [[-16, -8], [16, -8], [16, 16], [-16, 16]], '#7fd1b0', 2);
    SG.draw.poly(ctx, [[-8, -8], [-10, -20], [10, -20], [8, -8]], '#9fe6c8', 1.8);
    ctx.fillStyle = '#1e5a44'; ctx.font = '900 16px "Noto Serif TC", serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillText('璽', 0, 4);
    ctx.restore();
  }
  // 東風：畫面上往西（左）吹的風線
  drawWind(ctx, dt) {
    const [x0, y0, vw, vh] = this.view;
    if (!this.gusts) this.gusts = Array.from({ length: 46 }, () => ({ x: Math.random(), y: Math.random(), l: 60 + Math.random() * 140, v: 0.35 + Math.random() * 0.4 }));
    ctx.save(); ctx.strokeStyle = 'rgba(236,240,230,.35)'; ctx.lineWidth = 2; ctx.lineCap = 'round';
    for (const g of this.gusts) {
      g.x -= g.v * dt; if (g.x < -0.2) { g.x = 1.1; g.y = Math.random(); }
      const x = x0 + g.x * vw, y = y0 + g.y * vh;
      ctx.beginPath(); ctx.moveTo(x, y); ctx.quadraticCurveTo(x + g.l * 0.5, y - 6, x + g.l, y); ctx.stroke();
    }
    ctx.restore();
  }
  drawIce(ctx, u) {
    const s = (u.spec && u.spec.size) || 1, h = 104 * s, w = 54 * s * ((u.spec && u.spec.bulk) || 1);
    ctx.save();
    ctx.fillStyle = 'rgba(170,225,255,.38)'; ctx.strokeStyle = 'rgba(235,250,255,.9)'; ctx.lineWidth = 2;
    ctx.beginPath(); ctx.moveTo(u.x - w / 2, u.y); ctx.lineTo(u.x - w / 2 + 6, u.y - h); ctx.lineTo(u.x + w / 2 - 4, u.y - h - 6); ctx.lineTo(u.x + w / 2, u.y - 4); ctx.closePath(); ctx.fill(); ctx.stroke();
    ctx.strokeStyle = 'rgba(255,255,255,.7)'; ctx.beginPath(); ctx.moveTo(u.x - w / 2 + 12, u.y - h + 14); ctx.lineTo(u.x - w / 2 + 18, u.y - h * 0.5); ctx.stroke();
    ctx.restore();
  }
  // ================= 打擊感：頓幀、慢動作、擊殺墨印、升級光柱、殘血暈影 =================
  // 主迴圈用 timeScale() 縮放模擬與動畫的時間；頓幀只在跟玩家有關時發生，免得電腦互打一直卡
  timeScale(dt) {
    let k = 1;
    if (this.hs > 0) { this.hs -= dt; k = 0.06; }
    if (this.slowT > 0) { this.slowT -= dt; k = Math.min(k, 0.25 + 0.75 * Math.max(0, 1 - this.slowT / 2.4) ** 3); }
    return k;
  }
  juiceOn(o) {
    const me = this.me, J = (this.juice = this.juice || []);
    if (o.k === 'levelup') { if (o.id === me.id) J.push({ k: 'lv', t: 0, life: 1.1 }); return; }
    if (o.k === 'basefall') {
      this.slowT = 2.4; this.focus = { x: o.x, y: o.y, t: 2.6 }; this.WS.shake = Math.max(this.WS.shake, 24);
      J.push({ k: 'boom', x: o.x, y: o.y, t: 0, life: 2.2 });
      J.push({ k: 'stamp', text: o.team === this.team ? '城破' : '大勝', sub: o.team === this.team ? '本營失守' : '敵軍本營已破', ally: o.team !== this.team, t: 0, life: 3, big: 1 });
      if (SG.Audio) SG.Audio.play('gong');
      return;
    }
    // herokill
    const mine = o.by === me.id, died = o.tgt === me.id;
    const near = Math.hypot(o.x - this.cam.x, o.y - this.cam.y) < 900;
    if (!mine && !died && !near) return;
    this.WS.shake = Math.max(this.WS.shake, mine ? 14 : 7);
    J.push({ k: 'slash', x: o.x, y: o.y - 55, t: 0, life: 0.55, ally: !died && (mine || this.w.units.find((u) => u.id === o.by)?.team === this.team), seed: (o.x * 7 + o.y) % 1 });
    if (mine) {
      this.hs = 0.11;
      const T = { 2: '雙殺', 3: '三殺', 4: '四殺', 5: '五殺' };
      J.push({ k: 'stamp', text: T[o.multi] || '斬', sub: T[o.multi] ? '' : '', ally: true, t: 0, life: o.multi >= 2 ? 1.6 : 1.1, big: o.multi >= 3 ? 1 : 0 });
      J.push({ k: 'flash', t: 0, life: 0.18 });
    } else if (died) { this.hs = 0.08; J.push({ k: 'flash', t: 0, life: 0.25, red: 1 }); }
  }
  // 金甲、霜天等造型：腳下的光暈
  drawAura(ctx, u) {
    const t = this.WS.time, s = (u.spec.size || 1);
    ctx.save(); ctx.translate(u.x, u.y);
    const g = ctx.createRadialGradient(0, 0, 4, 0, 0, 46 * s);
    g.addColorStop(0, u.spec.aura + '88'); g.addColorStop(1, u.spec.aura + '00');
    ctx.fillStyle = g; ctx.beginPath(); ctx.ellipse(0, 0, 46 * s, 46 * s * SG.K * 0.6, 0, 0, Math.PI * 2); ctx.fill();
    ctx.strokeStyle = u.spec.aura; ctx.globalAlpha = 0.5 + 0.3 * Math.sin(t * 4); ctx.lineWidth = 1.5;
    ctx.beginPath(); ctx.ellipse(0, 0, 30 * s, 30 * s * SG.K * 0.6, 0, t % (Math.PI * 2), t % (Math.PI * 2) + 4.2); ctx.stroke();
    ctx.restore();
  }
  // ================= 地面痕跡：重砸留下裂痕、火與雷留下焦痕，幾秒後淡掉；重砸另外噴出碎石 =================
  decalOn(o) {
    const D = (this.decals = this.decals || []), seed = Math.random() * 1000;
    if (D.length > 60) D.shift();
    if (o.k === 'slam') {
      D.push({ k: 'crack', x: o.x, y: o.y, t: 0, life: 4.5, seed, r: o.small ? 50 : 90 });
      const R = (this.debris = this.debris || []);
      for (let i = 0; i < (o.small ? 5 : 10); i++) { const a = Math.random() * Math.PI * 2, v = 120 + Math.random() * 220; R.push({ x: o.x, y: o.y, z: 0, vx: Math.cos(a) * v, vy: Math.sin(a) * v * 0.5, vz: 260 + Math.random() * 260, r: 2 + Math.random() * 4, rot: Math.random() * 6, t: 0 }); }
    } else if (o.k === 'fire' && o.pal === 'ice') D.push({ k: 'frost', x: o.x, y: o.y, t: 0, life: 4, seed, r: 58 });
    else if (o.k === 'fire' || o.k === 'meteor') D.push({ k: 'scorch', x: o.x, y: o.y, t: 0, life: 5, seed, r: o.small ? 36 : o.k === 'meteor' ? 90 : 60 });
    else if (o.k === 'thunder') D.push({ k: 'scorch', x: o.x, y: o.y, t: 0, life: 3.5, seed, r: 42, zap: 1 });
  }
  drawDecals(ctx, dt) {
    const D = this.decals;
    if (D && D.length) {
      this.decals = D.filter((d) => (d.t += dt) < d.life);
      for (const d of this.decals) {
        const a = Math.min(1, (d.life - d.t) / 1.2), r = SG.MAP.rng((d.seed * 1000) | 0);
        ctx.save(); ctx.translate(d.x, d.y); ctx.globalAlpha = a;
        if (d.k === 'crack') {
          // 中心壓出一圈暗坑，向外放射幾道裂縫
          const g = ctx.createRadialGradient(0, 0, 4, 0, 0, d.r * 0.6); g.addColorStop(0, 'rgba(20,14,8,.5)'); g.addColorStop(1, 'rgba(20,14,8,0)');
          ctx.fillStyle = g; ctx.beginPath(); ctx.ellipse(0, 0, d.r * 0.6, d.r * 0.6 * SG.K, 0, 0, Math.PI * 2); ctx.fill();
          ctx.strokeStyle = 'rgba(24,16,10,.75)'; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
          for (let i = 0; i < 7; i++) {
            let ang = (i / 7) * Math.PI * 2 + r(), x = 0, y = 0, len = d.r * (0.6 + r() * 0.6);
            ctx.lineWidth = 3; ctx.beginPath(); ctx.moveTo(0, 0);
            for (let s = 0; s < 4; s++) { ang += (r() - 0.5) * 0.8; x += Math.cos(ang) * len / 4; y += Math.sin(ang) * len / 4 * SG.K; ctx.lineWidth = 3 - s * 0.6; ctx.lineTo(x, y); }
            ctx.stroke();
          }
          if (d.t < 0.8) { ctx.globalCompositeOperation = 'lighter'; ctx.globalAlpha = (0.8 - d.t) / 0.8 * 0.6; ctx.fillStyle = '#ffb050'; ctx.beginPath(); ctx.ellipse(0, 0, d.r * 0.25, d.r * 0.25 * SG.K, 0, 0, Math.PI * 2); ctx.fill(); }
        } else if (d.k === 'rune') {
          // 大招符陣：兩圈反向旋轉的光環，中間一圈符點，展開後淡掉
          const q = Math.min(1, d.t / 0.25), R = d.r * (0.6 + 0.4 * q), T = this.WS.time;
          ctx.globalCompositeOperation = 'lighter'; ctx.strokeStyle = d.col; ctx.lineWidth = 3;
          ctx.beginPath(); ctx.ellipse(0, 0, R, R * SG.K, 0, 0, Math.PI * 2); ctx.stroke();
          ctx.lineWidth = 1.6; ctx.setLineDash([14, 10]); ctx.lineDashOffset = T * 60;
          ctx.beginPath(); ctx.ellipse(0, 0, R * 0.78, R * 0.78 * SG.K, 0, 0, Math.PI * 2); ctx.stroke(); ctx.setLineDash([]);
          ctx.fillStyle = d.col;
          for (let i = 0; i < 8; i++) { const ang = -T * 1.5 + (i / 8) * Math.PI * 2; ctx.beginPath(); ctx.arc(Math.cos(ang) * R * 0.9, Math.sin(ang) * R * 0.9 * SG.K, 3.5, 0, Math.PI * 2); ctx.fill(); }
          const g = ctx.createRadialGradient(0, 0, 0, 0, 0, R); g.addColorStop(0, d.col); g.addColorStop(1, 'rgba(0,0,0,0)');
          ctx.globalAlpha = a * 0.35; ctx.fillStyle = g; ctx.beginPath(); ctx.ellipse(0, 0, R, R * SG.K, 0, 0, Math.PI * 2); ctx.fill();
        } else if (d.k === 'ink') {
          // 陣亡處的墨漬：不規則的暗斑加幾滴濺開的墨點
          ctx.fillStyle = 'rgba(14,10,8,.42)'; ctx.beginPath();
          for (let i = 0; i <= 10; i++) { const ang = (i / 10) * Math.PI * 2, rr = d.r * (0.6 + r() * 0.5); i ? ctx.lineTo(Math.cos(ang) * rr, Math.sin(ang) * rr * SG.K) : ctx.moveTo(Math.cos(ang) * rr, Math.sin(ang) * rr * SG.K); }
          ctx.closePath(); ctx.fill();
          for (let i = 0; i < 6; i++) { const ang = r() * Math.PI * 2, rr = d.r * (1 + r() * 0.8); ctx.beginPath(); ctx.ellipse(Math.cos(ang) * rr, Math.sin(ang) * rr * SG.K, 3 + r() * 4, 2 + r() * 2, 0, 0, Math.PI * 2); ctx.fill(); }
        } else if (d.k === 'frost') {
          // 冰霜：淡藍的結冰地面，幾道冰晶紋
          ctx.fillStyle = 'rgba(200,235,255,.32)'; ctx.beginPath(); ctx.ellipse(0, 0, d.r, d.r * SG.K, 0, 0, Math.PI * 2); ctx.fill();
          ctx.strokeStyle = 'rgba(235,250,255,.7)'; ctx.lineWidth = 1.4;
          for (let i = 0; i < 6; i++) { const ang = r() * Math.PI * 2, l = d.r * (0.4 + r() * 0.5), mx = Math.cos(ang) * l, my = Math.sin(ang) * l * SG.K;
            ctx.beginPath(); ctx.moveTo(0, 0); ctx.lineTo(mx, my); ctx.moveTo(mx * 0.6, my * 0.6); ctx.lineTo(mx * 0.6 + Math.cos(ang + 0.7) * l * 0.25, my * 0.6 + Math.sin(ang + 0.7) * l * 0.25 * SG.K); ctx.stroke(); }
        } else {
          // 焦痕：不規則的黑斑＋還在發光的餘燼
          ctx.fillStyle = 'rgba(16,10,6,.55)';
          ctx.beginPath();
          for (let i = 0; i <= 12; i++) { const ang = (i / 12) * Math.PI * 2, rr = d.r * (0.7 + r() * 0.4); i ? ctx.lineTo(Math.cos(ang) * rr, Math.sin(ang) * rr * SG.K) : ctx.moveTo(Math.cos(ang) * rr, Math.sin(ang) * rr * SG.K); }
          ctx.closePath(); ctx.fill();
          ctx.globalCompositeOperation = 'lighter';
          const glow = Math.max(0, 1 - d.t / (d.life * 0.7));
          for (let i = 0; i < 9; i++) { const ang = r() * Math.PI * 2, rr = r() * d.r * 0.8, fl = 0.6 + 0.4 * Math.sin(this.WS.time * 6 + i); ctx.globalAlpha = a * glow * fl; ctx.fillStyle = d.zap ? '#bfe6ff' : '#ff9a3a'; ctx.fillRect(Math.cos(ang) * rr, Math.sin(ang) * rr * SG.K, 3, 3); }
        }
        ctx.restore();
      }
    }
    // 揚塵：往後飄、慢慢變大變淡
    if (this.dust && this.dust.length) {
      this.dust = this.dust.filter((p) => (p.t += dt) < 0.55);
      for (const p of this.dust) {
        const k = p.t / 0.55; p.x += p.vx * dt;
        ctx.fillStyle = `rgba(150,130,96,${(0.35 * (1 - k)).toFixed(3)})`;
        ctx.beginPath(); ctx.ellipse(p.x, p.y - k * 6, (5 + k * 12) * p.s, (3 + k * 6) * p.s, 0, 0, Math.PI * 2); ctx.fill();
      }
    }
    // 碎石：拋物線飛出去、落地彈一下就停
    const R = this.debris;
    if (R && R.length) {
      this.debris = R.filter((p) => (p.t += dt) < 1.6);
      for (const p of this.debris) {
        if (p.z > 0 || p.vz > 0) { p.x += p.vx * dt; p.y += p.vy * dt; p.z += p.vz * dt; p.vz -= 1100 * dt; p.rot += dt * 8; if (p.z < 0) { p.z = 0; p.vz = Math.abs(p.vz) > 120 ? -p.vz * 0.3 : 0; p.vx *= 0.4; p.vy *= 0.4; } }
        ctx.save(); ctx.globalAlpha = Math.min(1, (1.6 - p.t) / 0.4);
        ctx.fillStyle = 'rgba(0,0,0,.25)'; ctx.beginPath(); ctx.ellipse(p.x, p.y, p.r, p.r * 0.4, 0, 0, Math.PI * 2); ctx.fill();
        ctx.translate(p.x, p.y - p.z); ctx.rotate(p.rot); ctx.fillStyle = '#6b5a40'; ctx.strokeStyle = SG.INK; ctx.lineWidth = 1;
        ctx.beginPath(); ctx.moveTo(-p.r, 0); ctx.lineTo(0, -p.r); ctx.lineTo(p.r, -p.r * 0.2); ctx.lineTo(p.r * 0.3, p.r); ctx.closePath(); ctx.fill(); ctx.stroke();
        ctx.restore();
      }
    }
  }
  // ================= 大招：施放瞬間的光柱、地面符陣、周圍壓暗；施放中的旋風與殘影 =================
  ultOn(o) {
    const u = this.w.units.find((x) => x.id === o.id);
    if (!u || (u.team !== this.team && !u.vis[this.team])) return;
    if (Math.hypot(u.x - this.cam.x, u.y - this.cam.y) > 1300) return;
    (this.ults = this.ults || []).push({ x: u.x, y: u.y, t: 0, col: (u.spec && u.spec.fx) || '#ffd46b', id: u.id });
    (this.decals = this.decals || []).push({ k: 'rune', x: u.x, y: u.y, t: 0, life: 1.6, seed: Math.random() * 1000, r: 120, col: (u.spec && u.spec.fx) || '#ffd46b' });
    this.WS.shake = Math.max(this.WS.shake, u === this.me ? 10 : 5);
  }
  // 這個單位身上正在生效的大招增益（大招的增益以招式名稱當 id）
  ultBuff(u) {
    if (!u.buffs) return null;
    for (const b of u.buffs) if (!b.neg && b.src && b.src.spec && b.src.spec.skills && b.src.spec.skills[3] && b.id === b.src.spec.skills[3].name) return b;
    return null;
  }
  drawUlts(ctx, dt) {
    const vp = this.vp;
    if (this.ults && this.ults.length) {
      this.ults = this.ults.filter((e) => (e.t += dt) < 1.2);
      for (const e of this.ults) {
        const k = e.t / 1.2;
        // 周圍壓暗：以施放者為中心，外圍暗一圈，前 0.6 秒最明顯
        if (vp && e.t < 0.7) {
          const g = ctx.createRadialGradient(e.x, e.y - 40, 160, e.x, e.y - 40, Math.max(vp.vw, vp.vh) * 0.75);
          g.addColorStop(0, 'rgba(6,8,12,0)'); g.addColorStop(1, `rgba(6,8,12,${(0.38 * (1 - e.t / 0.7)).toFixed(3)})`);
          ctx.fillStyle = g; ctx.fillRect(vp.x0, vp.y0, vp.vw, vp.vh);
        }
        // 光柱：先竄高再變細淡掉
        ctx.save(); ctx.globalCompositeOperation = 'lighter';
        const h = 420 * Math.min(1, k * 4), w = 46 * (1 - k) + 6;
        const g2 = ctx.createLinearGradient(0, e.y - h, 0, e.y);
        g2.addColorStop(0, 'rgba(255,255,255,0)'); g2.addColorStop(0.7, e.col); g2.addColorStop(1, '#ffffff');
        ctx.globalAlpha = 0.55 * (1 - k); ctx.fillStyle = g2; ctx.fillRect(e.x - w, e.y - h, w * 2, h);
        ctx.globalAlpha = 0.9 * (1 - k); ctx.fillStyle = '#ffffff'; ctx.fillRect(e.x - w * 0.25, e.y - h, w * 0.5, h);
        for (let i = 0; i < 10; i++) { const q = (k * 1.6 + i * 0.1) % 1; ctx.globalAlpha = (1 - q) * (1 - k); ctx.fillStyle = e.col; ctx.fillRect(e.x + Math.sin(i * 2.7) * w * 1.4, e.y - q * h, 3, 7); }
        ctx.restore();
      }
    }
    // 施放中的大招增益
    const T = this.WS.time;
    for (const u of this.w.units) {
      if (!u.alive || u.kind !== 'hero' || !u.buffs || (u.team !== this.team && !u.vis[this.team])) continue;
      if (vp && (u.x < vp.x0 - 300 || u.x > vp.x0 + vp.vw + 300 || u.y < vp.y0 - 300 || u.y > vp.y0 + vp.vh + 300)) continue;
      const b = this.ultBuff(u);
      if (!b) continue;
      const col = b.col || '#ffd46b';
      if (b.aoe) {
        // 旋風：繞著人轉的刀光＋風紋，半徑就是傷害範圍
        const R = (b.aoe.r || 160);
        ctx.save(); ctx.translate(u.x, u.y - 30); ctx.globalCompositeOperation = 'lighter'; ctx.lineCap = 'round';
        for (let i = 0; i < 3; i++) {
          const a0 = T * 9 + (i * Math.PI * 2) / 3;
          ctx.globalAlpha = 0.55; ctx.strokeStyle = col; ctx.lineWidth = 10;
          ctx.beginPath(); ctx.ellipse(0, 0, R * 0.85, R * 0.85 * SG.K, 0, a0, a0 + 1.1); ctx.stroke();
          ctx.globalAlpha = 0.9; ctx.strokeStyle = '#ffffff'; ctx.lineWidth = 2.5;
          ctx.beginPath(); ctx.ellipse(0, 0, R * 0.85, R * 0.85 * SG.K, 0, a0 + 0.5, a0 + 1.1); ctx.stroke();
        }
        ctx.strokeStyle = col; ctx.lineWidth = 2;
        for (let i = 0; i < 6; i++) { const a0 = -T * 5 + i; ctx.globalAlpha = 0.3; ctx.beginPath(); ctx.ellipse(0, -10 - i * 8, R * (0.35 + i * 0.07), R * (0.35 + i * 0.07) * SG.K * 0.6, 0, a0, a0 + 2); ctx.stroke(); }
        ctx.restore();
      } else if (b.ms > 0 || b.as > 0) {
        // 殘影：每 0.06 秒留下一個金色的身影，跟著淡掉
        const a = this.actors.get(u.id);
        if (a && a.P) {
          a.ghostT = (a.ghostT || 0) - dt;
          if (a.ghostT <= 0) { a.ghostT = 0.06; (this.ghosts = this.ghosts || []).push({ x: u.x, y: u.y, f: u.f, s: a.s, spec: u.spec, P: Object.assign({}, a.P), t: 0, col }); if (this.ghosts.length > 40) this.ghosts.shift(); }
        }
      }
    }
    if (this.ghosts && this.ghosts.length) {
      this.ghosts = this.ghosts.filter((g) => (g.t += dt) < 0.3);
      for (const g of this.ghosts) {
        ctx.save(); ctx.translate(g.x, g.y); ctx.scale(g.s * g.f, g.s); ctx.globalCompositeOperation = 'lighter'; ctx.globalAlpha = 0.35 * (1 - g.t / 0.3);
        SG.drawHero(ctx, g.spec, g.P, 0); ctx.restore();
      }
    }
  }
  // 陣亡的塵土圈與魂魄（武將）
  drawDeaths(ctx, dt) {
    if (!this.deaths || !this.deaths.length) return;
    this.deaths = this.deaths.filter((d) => (d.t += dt) < (d.big ? 1.6 : 0.6));
    ctx.save();
    for (const d of this.deaths) {
      const k = Math.min(1, d.t / 0.6);
      ctx.globalAlpha = 0.5 * (1 - k); ctx.fillStyle = '#9a8a6a';
      for (let i = 0; i < 8; i++) { const ang = (i / 8) * Math.PI * 2, rr = (14 + 46 * k) * (d.big ? 1.2 : 0.8); ctx.beginPath(); ctx.ellipse(d.x + Math.cos(ang) * rr, d.y + Math.sin(ang) * rr * SG.K - 4, 10 * (1 - k * 0.5), 6, 0, 0, Math.PI * 2); ctx.fill(); }
      if (d.big) {
        ctx.globalCompositeOperation = 'lighter';
        for (let i = 0; i < 5; i++) {
          const q = Math.max(0, d.t - i * 0.12) / 1.4; if (q <= 0 || q >= 1) continue;
          const x = d.x + Math.sin(q * 6 + i * 2) * 14 + (i - 2) * 10, y = d.y - 40 - q * 150;
          ctx.globalAlpha = 0.55 * (1 - q); ctx.fillStyle = d.col;
          ctx.beginPath(); ctx.ellipse(x, y, 5 * (1 - q * 0.5), 11 * (1 - q * 0.5), 0, 0, Math.PI * 2); ctx.fill();
          ctx.fillStyle = '#ffffff'; ctx.beginPath(); ctx.arc(x, y - 2, 2, 0, Math.PI * 2); ctx.fill();
        }
        ctx.globalCompositeOperation = 'source-over';
      }
    }
    ctx.restore();
  }
  // 打擊火花：白黃色的放射短線＋一圈擴散的環，0.22 秒
  drawHits(ctx, dt) {
    if (!this.hits || !this.hits.length) return;
    this.hits = this.hits.filter((h) => (h.t += dt) < 0.22);
    ctx.save(); ctx.globalCompositeOperation = 'lighter'; ctx.lineCap = 'round';
    for (const h of this.hits) {
      const k = h.t / 0.22, s = h.size;
      ctx.globalAlpha = 1 - k;
      for (let i = 0; i < 7; i++) {
        const a = h.seed + i * 0.9, r0 = (6 + 22 * k) * s, r1 = (14 + 34 * k) * s;
        ctx.strokeStyle = i % 2 ? '#ffd46b' : '#ffffff'; ctx.lineWidth = (i % 2 ? 2 : 3) * (1 - k) * Math.min(1.5, s) + 0.4;
        ctx.beginPath(); ctx.moveTo(h.x + Math.cos(a) * r0, h.y + Math.sin(a) * r0 * 0.8); ctx.lineTo(h.x + Math.cos(a) * r1, h.y + Math.sin(a) * r1 * 0.8); ctx.stroke();
      }
      ctx.strokeStyle = 'rgba(255,240,200,.8)'; ctx.lineWidth = 2 * (1 - k);
      ctx.beginPath(); ctx.ellipse(h.x, h.y, (8 + 30 * k) * s, (6 + 22 * k) * s, 0, 0, Math.PI * 2); ctx.stroke();
      if (k < 0.35) { ctx.fillStyle = '#ffffff'; ctx.globalAlpha = 1 - k / 0.35; ctx.beginPath(); ctx.arc(h.x, h.y, 7 * s * (1 - k), 0, Math.PI * 2); ctx.fill(); }
    }
    ctx.restore();
  }
  drawJuiceWorld(ctx, dt) {
    this.drawHits(ctx, dt); this.drawDeaths(ctx, dt); this.drawUlts(ctx, dt);
    const J = this.juice;
    if (!J || !J.length) return;
    const me = this.me;
    for (const j of J) {
      const u = j.t / j.life;
      if (j.k === 'slash') {
        // 一刀墨痕：先劃出去再淡掉
        const len = 150, grow = Math.min(1, u * 4), a = 1 - Math.max(0, (u - 0.4) / 0.6);
        ctx.save(); ctx.translate(j.x, j.y); ctx.rotate(-0.5 + j.seed * 0.3);
        ctx.globalAlpha = a;
        ctx.fillStyle = '#0c0b0a';
        ctx.beginPath(); ctx.moveTo(-len / 2, 2); ctx.quadraticCurveTo(0, -12 * grow, -len / 2 + len * grow, -3); ctx.quadraticCurveTo(0, 8, -len / 2, 2); ctx.fill();
        ctx.fillStyle = j.ally ? '#ffd46b' : '#e05a3a';
        ctx.beginPath(); ctx.moveTo(-len / 2, 0); ctx.quadraticCurveTo(0, -8 * grow, -len / 2 + len * grow, -3); ctx.quadraticCurveTo(0, 3, -len / 2, 0); ctx.fill();
        ctx.restore();
      } else if (j.k === 'lv' && me.alive) {
        // 升級：金色光柱＋擴散的地面圈
        ctx.save(); ctx.translate(me.x, me.y);
        const a = 1 - u, r = 20 + u * 90;
        ctx.globalAlpha = a; ctx.strokeStyle = '#ffd46b'; ctx.lineWidth = 3;
        ctx.beginPath(); ctx.ellipse(0, 0, r, r * SG.K * 0.6, 0, 0, Math.PI * 2); ctx.stroke();
        const g = ctx.createLinearGradient(0, -180, 0, 0); g.addColorStop(0, 'rgba(255,212,107,0)'); g.addColorStop(1, 'rgba(255,212,107,.55)');
        ctx.fillStyle = g; ctx.fillRect(-26 * (1 - u * 0.5), -180, 52 * (1 - u * 0.5), 180);
        ctx.fillStyle = '#fff3c4';
        for (let i = 0; i < 8; i++) { const ph = (i * 0.37 + u) % 1; ctx.globalAlpha = a * (1 - ph); ctx.fillRect(Math.sin(i * 2.3) * 22, -ph * 170, 3, 3); }
        ctx.restore();
      } else if (j.k === 'boom') {
        ctx.save(); ctx.translate(j.x, j.y);
        for (let i = 0; i < 3; i++) {
          const uu = Math.max(0, u - i * 0.15), r = 40 + uu * 420;
          ctx.globalAlpha = Math.max(0, 0.8 - uu); ctx.strokeStyle = i ? '#e05a3a' : '#ffd46b'; ctx.lineWidth = 8 - i * 2;
          ctx.beginPath(); ctx.ellipse(0, 0, r, r * SG.K, 0, 0, Math.PI * 2); ctx.stroke();
        }
        ctx.restore();
      }
    }
  }
  drawJuiceScreen(dt) {
    const ctx = this.ctx, W = this.cw, H = this.ch, me = this.me;
    ctx.save(); ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
    // 殘血：畫面邊緣紅色脈動
    if (me.alive && me.hp < me.maxHp * 0.3) {
      const k = 1 - me.hp / (me.maxHp * 0.3), p = 0.55 + 0.45 * Math.sin(this.WS.time * (4 + k * 4));
      const g = ctx.createRadialGradient(W / 2, H / 2, Math.min(W, H) * 0.35, W / 2, H / 2, Math.max(W, H) * 0.72);
      g.addColorStop(0, 'rgba(160,20,20,0)'); g.addColorStop(1, `rgba(160,20,20,${(0.25 + 0.35 * k) * p})`);
      ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
    }
    const J = this.juice;
    if (J && J.length) {
      for (const j of J) {
        j.t += dt / Math.max(0.06, this.lastK || 1); // 這些特效用真實時間跑，不受頓幀影響
        const u = j.t / j.life;
        if (j.k === 'flash') { ctx.fillStyle = j.red ? `rgba(200,30,30,${0.35 * (1 - u)})` : `rgba(255,240,200,${0.22 * (1 - u)})`; ctx.fillRect(0, 0, W, H); }
        else if (j.k === 'stamp') {
          // 書法大字：蓋下去（放大→落定），最後淡出
          const inU = Math.min(1, j.t / 0.16), sc = 1 + (1 - inU) * 1.4, a = u > 0.75 ? 1 - (u - 0.75) / 0.25 : 1;
          const size = j.big ? Math.min(220, W * 0.2) : Math.min(140, W * 0.13), x = W / 2, y = H * 0.34;
          const img = this.stampImage(j, size);
          ctx.save(); ctx.translate(x, y); ctx.scale(sc, sc); ctx.rotate(-0.06); ctx.globalAlpha = a * inU;
          ctx.drawImage(img.c, -img.ox, -img.oy, img.c.width / img.dpr, img.c.height / img.dpr);
          ctx.restore();
        }
      }
      this.juice = J.filter((j) => j.t < j.life);
    }
    ctx.restore();
  }
  // 書法大字（stamp）先畫進一張離屏畫布，之後每幀只縮放、旋轉、調透明度貼上去（v0.5.4.2）。
  // 以前每幀直接 strokeText／fillText，字級最大 220，蓋下去的動畫再放大到 2.4 倍、Retina 再 ×2：
  // 每幀尺寸都不同，顯示卡的字形快取用不上，每幀都要重算上千像素高的中文字形和粗描邊，畫面會卡一下
  stampImage(j, size) {
    const dpr = this.dpr || 1;
    if (j.img && j.img.size === size && j.img.dpr === dpr) return j.img;
    const font = `900 ${size}px "Noto Serif TC", "Songti TC", serif`, c = document.createElement('canvas');
    let x = c.getContext('2d');
    x.font = font;
    const hw = Math.max(size * 2.3, x.measureText(j.text).width / 2 + size * 0.12) + 8, top = size * 0.75, bot = size * (j.sub ? 1 : 0.75);
    c.width = Math.ceil(hw * 2 * dpr); c.height = Math.ceil((top + bot) * dpr);
    x = c.getContext('2d'); x.setTransform(dpr, 0, 0, dpr, hw * dpr, top * dpr);
    if (SG.Share) SG.Share.brush(x, -size * 0.9, size * 0.08, size * 0.9 * (j.text.length > 1 ? 1.4 : 1), -size * 0.02, size * 0.9, j.ally ? 'rgba(142,43,34,.85)' : 'rgba(40,30,70,.85)', 11);
    x.font = font; x.textAlign = 'center'; x.textBaseline = 'middle';
    x.lineWidth = size * 0.08; x.strokeStyle = '#0c0b0a'; x.strokeText(j.text, 0, 0);
    x.fillStyle = j.ally ? '#ffe7a8' : '#d8c8ff'; x.fillText(j.text, 0, 0);
    if (j.sub) { x.font = `700 ${size * 0.18}px "Noto Sans TC", sans-serif`; x.lineWidth = 4; x.strokeText(j.sub, 0, size * 0.72); x.fillStyle = '#ece4d2'; x.fillText(j.sub, 0, size * 0.72); }
    return (j.img = { c, size, dpr, ox: hw, oy: top });
  }
  // 大招特寫：格鬥遊戲式斜切橫幅（我方從左、敵方從右滑入）
  startCutin(o) {
    const u = this.w.units.find((x) => x.id === o.id);
    if (this.noCutin || !u || !u.spec || !u.spec.skills) return;
    if (u.team !== this.team && !u.vis[this.team]) return;
    const near = Math.hypot(u.x - this.cam.x, u.y - this.cam.y) < 1300;
    if (!near && u.team !== this.team) return;
    this.cut = { spec: u.spec, sk: u.spec.skills[3].name, who: u.name, ally: u.team === this.team, mine: u === this.me, t: 0 };
    if (SG.Audio) SG.Audio.play('ult', u.x, u.y, this, near ? 1 : 0.5);
  }
  // 大招小卡片：我方在左上、敵方在右上，不遮住戰場中央
  drawCutin(dt) {
    const c = this.cut;
    if (!c) return;
    c.t += dt;
    if (c.t > 1.6) { this.cut = null; return; }
    const ctx = this.ctx, W = this.cw, k = c.t;
    const slide = k < 0.15 ? k / 0.15 : k > 1.3 ? Math.max(0, 1 - (k - 1.3) / 0.3) : 1;
    const cw = Math.min(360, W * 0.42), ch = 84, y = c.ally ? this.cardY || 170 : 170;
    const x = c.ally ? 12 - (1 - slide) * (cw + 20) : W - cw - 12 + (1 - slide) * (cw + 20);
    ctx.save(); ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0); ctx.globalAlpha = Math.min(1, slide * 1.3);
    const card = () => { ctx.beginPath(); ctx.moveTo(x + 14, y); ctx.lineTo(x + cw, y); ctx.lineTo(x + cw - 14, y + ch); ctx.lineTo(x, y + ch); ctx.closePath(); };
    const g = ctx.createLinearGradient(x, y, x + cw, y);
    g.addColorStop(0, c.ally ? 'rgba(70,48,14,.94)' : 'rgba(46,28,72,.94)'); g.addColorStop(1, 'rgba(12,14,20,.9)');
    card(); ctx.fillStyle = g; ctx.fill(); ctx.lineWidth = 2; ctx.strokeStyle = c.ally ? '#f0b43c' : '#b57cff'; ctx.stroke();
    ctx.save(); card(); ctx.clip();
    ctx.translate(x + 52, y + ch + 58); ctx.scale(1.25, 1.25);
    SG.drawHero(ctx, c.spec, SG.poseOf(c.spec, 's3', 0.35), this.WS.time * 1000);
    ctx.restore();
    ctx.textAlign = 'left'; ctx.textBaseline = 'middle';
    ctx.font = '900 26px "Noto Serif TC", "Songti TC", serif'; ctx.lineWidth = 4; ctx.strokeStyle = '#0c0e14';
    ctx.strokeText(c.sk, x + 108, y + 34); ctx.fillStyle = c.ally ? '#ffe7a8' : '#e7d0ff'; ctx.fillText(c.sk, x + 108, y + 34);
    ctx.font = '700 12px "Noto Sans TC", sans-serif'; ctx.fillStyle = '#d8cdb5'; ctx.fillText((c.ally ? '我方 · ' : '敵方 · ') + c.who + (c.mine ? '（你）' : ''), x + 108, y + 62);
    ctx.restore();
  }
  tag(ctx, x, y, t) {
    ctx.save(); ctx.font = '700 12px "Noto Sans TC", sans-serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    const w = ctx.measureText(t).width + 12;
    ctx.fillStyle = 'rgba(12,14,20,.85)'; ctx.fillRect(x - w / 2, y - 10, w, 20); ctx.fillStyle = '#ffcf6a'; ctx.fillText(t, x, y);
    ctx.restore();
  }
  mark(x, y, col) { this.marks.push({ x, y, t: 0, col: col || '#8fe08a' }); }
  ping(o) { this.pings.push(Object.assign({ t: 0 }, o)); if (this.pings.length > 12) this.pings.shift(); }
  // 地上：三圈往外擴的光環＋一根光柱＋圖示字；跟著目標單位走
  drawPings(ctx, dt) {
    const K = SG.K;
    this.pings = this.pings.filter((p) => (p.t += dt) < PING_LIFE);
    for (const p of this.pings) {
      const d = PINGS[p.k] || PINGS.go, u = p.uid != null ? this.w.units.find((x) => x.id === p.uid && x.alive) : null, x = u ? u.x : p.x, y = u ? u.y : p.y;
      const fade = p.t > PING_LIFE - 0.6 ? (PING_LIFE - p.t) / 0.6 : 1;
      ctx.save(); ctx.globalAlpha = fade; ctx.strokeStyle = d.col; ctx.fillStyle = d.col;
      for (let i = 0; i < 3; i++) { const f = ((p.t * 1.4 + i / 3) % 1), r = 20 + f * 90; ctx.globalAlpha = fade * (1 - f) * 0.9; ctx.lineWidth = 3; ctx.beginPath(); ctx.ellipse(x, y, r, r * K, 0, 0, Math.PI * 2); ctx.stroke(); }
      ctx.globalAlpha = fade * 0.35; const g = ctx.createLinearGradient(0, y - 170, 0, y); g.addColorStop(0, 'rgba(0,0,0,0)'); g.addColorStop(1, d.col); ctx.fillStyle = g; ctx.fillRect(x - 5, y - 170, 10, 170);
      const pop = p.t < 0.15 ? 1.6 - p.t * 4 : 1, by = y - 190 - Math.sin(p.t * 5) * 4;
      ctx.globalAlpha = fade; ctx.translate(x, by); ctx.scale(pop, pop);
      ctx.fillStyle = 'rgba(12,14,20,.85)'; ctx.strokeStyle = d.col; ctx.lineWidth = 3; ctx.beginPath(); ctx.arc(0, 0, 20, 0, Math.PI * 2); ctx.fill(); ctx.stroke();
      ctx.fillStyle = d.col; ctx.font = '900 20px "Noto Serif TC", serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillText(d.ch, 0, 1);
      ctx.font = '700 13px "Noto Sans TC", sans-serif'; ctx.lineWidth = 3; ctx.strokeStyle = 'rgba(12,14,20,.9)'; const label = (p.name ? p.name + '：' : '') + d.name;
      ctx.strokeText(label, 0, -34); ctx.fillStyle = '#fff'; ctx.fillText(label, 0, -34);
      ctx.restore();
    }
  }
  drawMarks(ctx, dt) {
    // Shift＋右鍵排好的路徑（v0.3.8）：從武將連到每個路徑點的虛線，點上一面小旗
    if (this.wps.length && this.me && this.me.alive) {
      ctx.save(); ctx.strokeStyle = 'rgba(143,224,138,.75)'; ctx.lineWidth = 2; ctx.setLineDash([8, 7]); ctx.lineDashOffset = -this.WS.time * 20;
      ctx.beginPath(); ctx.moveTo(this.me.x, this.me.y); for (const p of this.wps) ctx.lineTo(p[0], p[1]); ctx.stroke(); ctx.setLineDash([]);
      this.wps.forEach((p, i) => {
        ctx.fillStyle = 'rgba(143,224,138,.25)'; ctx.strokeStyle = '#8fe08a'; ctx.lineWidth = 1.6;
        ctx.beginPath(); ctx.ellipse(p[0], p[1], 12, 12 * SG.K, 0, 0, Math.PI * 2); ctx.fill(); ctx.stroke();
        ctx.strokeStyle = '#2a3a2a'; ctx.beginPath(); ctx.moveTo(p[0], p[1]); ctx.lineTo(p[0], p[1] - 26); ctx.stroke();
        ctx.fillStyle = '#8fe08a'; ctx.beginPath(); ctx.moveTo(p[0], p[1] - 26); ctx.lineTo(p[0] + 13, p[1] - 21); ctx.lineTo(p[0], p[1] - 16); ctx.closePath(); ctx.fill();
        ctx.fillStyle = '#10140f'; ctx.font = '700 9px sans-serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillText(String(i + 1), p[0] + 5, p[1] - 21);
      });
      ctx.restore();
    }
    this.marks = this.marks.filter((m) => (m.t += dt) < 0.5);
    for (const m of this.marks) {
      const k = m.t / 0.5;
      ctx.save(); ctx.globalAlpha = 1 - k; ctx.strokeStyle = m.col; ctx.lineWidth = 2.5;
      ctx.beginPath(); ctx.ellipse(m.x, m.y, 26 * (1 - k * 0.6), 26 * SG.K * (1 - k * 0.6), 0, 0, Math.PI * 2); ctx.stroke(); ctx.restore();
    }
  }
  drawHover(ctx, u) {
    const r = this.rel(u), col = this.w.canDeny(this.me, u) ? '#ff9a5a' : r === 'ally' ? COL.ally : r === 'neutral' ? '#ffb24a' : '#ff5a5a';
    const rr = (u.structure ? u.r : 30 * ((u.spec && u.spec.size) || 1) * (u.kind === 'minion' ? 0.74 : 1));
    ctx.save(); ctx.strokeStyle = col; ctx.lineWidth = 3; ctx.shadowColor = col; ctx.shadowBlur = 8;
    ctx.beginPath(); ctx.ellipse(u.x, u.y, rr + 6, (rr + 6) * 0.35 + 4, 0, 0, Math.PI * 2); ctx.stroke(); ctx.restore();
  }
  // 技能範圍指示：方向（長條）、扇形、指定地點（最遠距離＋落點範圍）、自身範圍
  drawIndicator(ctx) {
    const ind = this.indicator, me = this.me;
    if (!ind || !me.alive || !this.aim) return;
    const K = SG.K, sk = SG.skillAt(me, ind.i), A = SG.aimOf(sk, me.skillLv[ind.i]), R = this.w.skillRange(sk, me.skillLv[ind.i]);
    const dir = SG.dirTo(me, this.aim[0], this.aim[1]);
    const ok = me.cd[ind.i] <= 0 && me.skillLv[ind.i] > 0 && me.mp >= this.w.skillCost(ind.i, Math.max(1, me.skillLv[ind.i]), sk);
    const fill = ok ? 'rgba(143,224,138,.16)' : 'rgba(255,120,110,.14)', line = ok ? 'rgba(143,224,138,.85)' : 'rgba(255,120,110,.8)';
    const P = (d, off) => { const p = SG.along(me.x, me.y, dir, d); return [p[0] - dir[1] * off, p[1] + dir[0] * off * K]; };
    ctx.save(); ctx.fillStyle = fill; ctx.strokeStyle = line; ctx.lineWidth = 2; ctx.setLineDash([8, 6]);
    const ell = (x, y, r) => { ctx.beginPath(); ctx.ellipse(x, y, r, r * K, 0, 0, Math.PI * 2); };
    if (A.kind === 'dir') {
      const w = A.width;
      const pts = [P(20, -w), P(R, -w), P(R, w), P(20, w)];
      ctx.beginPath(); pts.forEach((p, i) => (i ? ctx.lineTo(p[0], p[1]) : ctx.moveTo(p[0], p[1]))); ctx.closePath(); ctx.fill(); ctx.stroke();
      ctx.setLineDash([]); const tip = P(R, 0), b1 = P(R - 30, -w * 0.8), b2 = P(R - 30, w * 0.8);
      ctx.beginPath(); ctx.moveTo(b1[0], b1[1]); ctx.lineTo(tip[0], tip[1]); ctx.lineTo(b2[0], b2[1]); ctx.stroke();
    } else if (A.kind === 'cone') {
      const half = Math.acos(A.cos), base = Math.atan2(dir[1], dir[0]);
      ctx.beginPath(); ctx.moveTo(me.x, me.y);
      for (let i = 0; i <= 16; i++) { const a = base - half + (2 * half * i) / 16; ctx.lineTo(me.x + Math.cos(a) * A.range, me.y + Math.sin(a) * A.range * K); }
      ctx.closePath(); ctx.fill(); ctx.stroke();
    } else if (A.kind === 'unit') { // 指定單體：射程圈＋目標標記
      ell(me.x, me.y, R); ctx.stroke(); ctx.setLineDash([]);
      const t = this.aimUnit;
      if (t) {
        const inR = SG.gd(me.x, me.y, t.x, t.y) <= R + t.r, foe = t.team !== me.team;
        ctx.strokeStyle = !inR ? 'rgba(255,200,90,.9)' : foe ? 'rgba(255,90,80,.95)' : 'rgba(143,224,138,.95)'; ctx.lineWidth = 3;
        ell(t.x, t.y, t.r + 14); ctx.stroke();
        ctx.lineWidth = 1.5; ctx.setLineDash([4, 6]); ctx.beginPath(); ctx.moveTo(me.x, me.y - 40); ctx.lineTo(t.x, t.y - 40); ctx.stroke();
      } else { ctx.setLineDash([3, 5]); ell(this.aim[0], this.aim[1], 18); ctx.stroke(); }
    } else if (A.kind === 'point') {
      ell(me.x, me.y, R); ctx.stroke();
      const d = Math.min(R, SG.gd(me.x, me.y, this.aim[0], this.aim[1])), p = SG.along(me.x, me.y, dir, d);
      ctx.setLineDash([]);
      if (A.line) { // 長條：沿垂直於施放方向展開 半長，厚 寬
        const home = A.face === 'home' && SG.MAP.bases[me.team], b = home ? SG.dirTo({ x: p[0], y: p[1], f: 1 }, home.x, home.y) : null;
        const n = b ? [-b[0], -b[1]] : dir, off = A.off || 0; // 長條的法線：施放方向，或背對本營（城垛面向敵方）
        const [h, th] = A.line, c = (s, o) => [p[0] - n[1] * s + n[0] * (o + off), p[1] + (n[0] * s + n[1] * (o + off)) * K];
        const pts = [c(-h, -th / 2), c(h, -th / 2), c(h, th / 2), c(-h, th / 2)];
        ctx.beginPath(); pts.forEach((q, i) => (i ? ctx.lineTo(q[0], q[1]) : ctx.moveTo(q[0], q[1]))); ctx.closePath(); ctx.fill(); ctx.stroke();
      } else { ell(p[0], p[1], Math.max(A.area, 24)); ctx.fill(); ctx.stroke(); }
    } else if (A.area) { ell(me.x, me.y, A.area); ctx.fill(); ctx.stroke(); }
    ctx.restore();
  }
  // 投射物拖尾：記住最近幾幀的位置，畫一條越往後越細越淡的光帶
  drawTrail(ctx, p) {
    if (p.hook || p.shape === 'ink' || p.shape === 'card') return; // 墨跡、竹牌不拖光軌
    const T = (this.trails = this.trails || new WeakMap());
    let tr = T.get(p);
    if (!tr) T.set(p, (tr = []));
    const y = p.homing ? p.y : p.y - 50;
    tr.push([p.x, y]); if (tr.length > 9) tr.shift();
    if (tr.length < 3) return;
    const col = p.shape === 'dart' ? '#9be36a' : p.col || (p.el && SG.EL ? SG.EL[p.el].col : p.homing ? '#e6ebf0' : '#ffffff');
    ctx.save(); ctx.globalCompositeOperation = 'lighter'; ctx.lineCap = 'round'; ctx.strokeStyle = col;
    for (let i = 1; i < tr.length; i++) {
      const k = i / (tr.length - 1);
      ctx.globalAlpha = 0.5 * k; ctx.lineWidth = (p.big ? 10 : p.homing ? 3 : 6) * k;
      ctx.beginPath(); ctx.moveTo(tr[i - 1][0], tr[i - 1][1]); ctx.lineTo(tr[i][0], tr[i][1]); ctx.stroke();
    }
    ctx.restore();
  }
  drawProjs(ctx, inView) {
    if (!this.seenP) this.seenP = new WeakSet();
    for (const p of this.w.projs) {
      if (!this.seenP.has(p)) { this.seenP.add(p); if (SG.Audio && inView(p.x, p.y, 200) && !this.w.net) SG.Audio.proj(p, this); }
      if (!p.visual || !inView(p.x, p.y, 60)) continue;
      if (p.team !== this.team && p.owner && p.owner.st && p.owner.st.invis > 0) continue;
      this.drawTrail(ctx, p);
      ctx.save();
      if (p.homing) { // 追蹤型（普攻、城寨箭）：照投射物外觀畫（v0.3.4：以前一律畫成箭）
        ctx.translate(p.x, p.y); ctx.rotate(p.ang || 0);
        if (!p.tower) ctx.scale(1.3, 1.3); // 武將普攻放大一點，兵器差異看得清楚
        if (!(SG.legendProj && SG.legendProj(ctx, p, this.WS, true))) SG.FX.bolt(ctx, { shape: p.shape || 'arrow', col: p.col || '#e6ebf0', big: p.big, h: 0, noStreak: true }, 0.3, this.WS.time);
      } else if (p.hook) {
        const o = p.owner, hx = o.x + o.f * 20, hy = o.y - 48;
        const ex = p.x, ey = p.y - 48, L = Math.hypot(ex - hx, ey - hy), n = Math.max(1, Math.floor(L / 8));
        ctx.fillStyle = '#9aa1a8'; ctx.strokeStyle = SG.INK; ctx.lineWidth = 1;
        for (let i = 0; i <= n; i++) { const q = i / n; ctx.beginPath(); ctx.ellipse(hx + (ex - hx) * q, hy + (ey - hy) * q, 3.4, 2.2, Math.atan2(ey - hy, ex - hx), 0, Math.PI * 2); ctx.fill(); ctx.stroke(); }
        ctx.translate(ex, ey); ctx.rotate(Math.atan2(ey - hy, ex - hx));
        ctx.beginPath(); ctx.moveTo(0, 0); ctx.quadraticCurveTo(12, -2, 10, 10); ctx.quadraticCurveTo(6, 6, 4, 8); ctx.lineWidth = 3.4; ctx.strokeStyle = '#d6dce2'; ctx.stroke();
      } else {
        ctx.fillStyle = 'rgba(8,8,6,.3)'; ctx.beginPath(); ctx.ellipse(p.x, p.y, 10, 4, 0, 0, Math.PI * 2); ctx.fill();
        ctx.translate(p.x, p.y - 50); ctx.rotate(Math.atan2(p.vy || 0, p.vx || p.f));
        if (!(SG.legendProj && SG.legendProj(ctx, p, this.WS, false))) SG.FX.bolt(ctx, { shape: p.shape, col: p.col || (p.el && SG.EL ? SG.EL[p.el].col : '#ffffff'), big: p.big, h: 0 }, 0.3, this.WS.time);
        if (SG.elProj) SG.elProj(this.WS, p);
      }
      ctx.restore();
    }
  }
  drawBar(ctx, u) {
    const r = this.rel(u);
    if (u.kind === 'minion' && u.hp >= u.maxHp - 1) return;
    const big = u.structure || u.kind === 'boss' || u.kind === 'cart', hero = u.kind === 'hero';
    const w = u.kind === 'base' ? 120 : u.structure ? 76 : u.kind === 'boss' ? 90 : hero ? 54 : 28;
    const scale = u.beast ? SG.BEAST_SIZE[u.beast] || 1 : u.spec && u.spec.size ? u.spec.size : 1; // 召喚獸依造型（SG.BEAST_SIZE）
    const y = u.kind === 'base' ? u.y - 330 : u.kind === 'tower' ? u.y - 222 : u.kind === 'barracks' || u.kind === 'granary' ? u.y - 176 : u.kind === 'cart' ? u.y - 96 : u.y - (hero || u.kind === 'boss' ? 118 : 86) * scale;
    const x = u.x;
    ctx.save();
    ctx.fillStyle = 'rgba(12,14,20,.85)'; ctx.fillRect(x - w / 2 - 1.5, y - 1.5, w + 3, (big || hero ? 7 : 4) + 3);
    const me = this.me, killable = u.kind === 'minion' && r === 'foe' && me.alive && u.hp <= (me.atk || 0) * 100 / 112;
    ctx.fillStyle = u.isPlayer ? '#8fe08a' : killable ? '#ffffff' : COL[r];
    ctx.fillRect(x - w / 2, y, w * Math.max(0, u.hp / u.maxHp), big || hero ? 7 : 4);
    if (killable) { ctx.strokeStyle = '#ffd24a'; ctx.lineWidth = 1.5; ctx.strokeRect(x - w / 2 - 2, y - 2, w + 4, 8); }
    if (u.st && u.st.shield > 0) { ctx.fillStyle = 'rgba(255,255,255,.75)'; ctx.fillRect(x - w / 2, y, Math.min(w, (w * u.st.shield) / u.maxHp), 2); }
    if (hero) {
      ctx.fillStyle = SG.isNeng(u) ? 'rgba(255,214,74,.95)' : 'rgba(111,179,255,.9)'; if (u.maxMp) ctx.fillRect(x - w / 2, y + 8, w * (u.mp / u.maxMp), 2.5); // 能是黃條；不耗資源沒有這條
      ctx.fillStyle = 'rgba(12,14,20,.9)'; ctx.fillRect(x - w / 2 - 19, y - 3, 16, 14);
      ctx.fillStyle = '#f3ead6'; ctx.font = '500 10px "IBM Plex Mono", monospace'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillText(u.lv, x - w / 2 - 11, y + 4);
    }
    if (hero || big) {
      ctx.font = '700 12px "Noto Sans TC", sans-serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'bottom';
      ctx.lineJoin = 'round'; ctx.lineWidth = 3; ctx.strokeStyle = 'rgba(12,14,20,.9)';
      const label = u.kind === 'granary' && this.w.structureLocked(u) ? '糧倉（無敵）' : u.kind === 'barracks' && this.w.structureLocked(u) ? '兵營（無敵）' : u.kind === 'tower' && this.w.structureLocked(u) ? '城寨（無敵）' : u.kind === 'base' && this.w.structureLocked(u) ? '本營（無敵）' : u.name;
      ctx.strokeText(label, x, y - 3); ctx.fillStyle = u.isPlayer ? '#ffffff' : '#f3ead6'; ctx.fillText(label, x, y - 3);
    }
    if (u.st && !u.structure) {
      const S = u.st, ic = [];
      if (S.knockup > 0) ic.push(['飛', '#ffd46b']); if (S.down > 0) ic.push(['倒', '#ffd46b']); if (S.freeze > 0) ic.push(['凍', '#9fe7ff']);
      if (S.stun > 0) ic.push(['暈', '#ffd46b']); if (S.fear > 0) ic.push(['懼', '#c9a2ff']); if (S.root > 0) ic.push(['定', '#8fe08a']);
      if (S.taunt > 0) ic.push(['嘲', '#ff8a6a']); if (S.charm > 0) ic.push(['惑', '#ff9ec8']); if (S.confuse > 0) ic.push(['亂', '#c9a2ff']);
      if (S.silence > 0) ic.push(['默', '#9fb6d8']); if (S.disarm > 0) ic.push(['繳', '#d8cdb5']); if (S.slow > 0 && S.slowAmt > 0.05) ic.push(['緩', '#9fe7ff']);
      ctx.font = '900 12px "Noto Serif TC", serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ic.slice(0, 3).forEach(([t, c], i) => {
        const ix = x + w / 2 + 10 + i * 16, iy = y + 3;
        ctx.fillStyle = 'rgba(12,14,20,.9)'; ctx.fillRect(ix - 7, iy - 7, 14, 14); ctx.strokeStyle = c; ctx.lineWidth = 1; ctx.strokeRect(ix - 7, iy - 7, 14, 14);
        ctx.fillStyle = c; ctx.fillText(t, ix, iy + 0.5);
      });
    }
    ctx.restore();
  }
  drawRuin(ctx, u) {
    ctx.save(); ctx.translate(u.x, u.y);
    const s = u.kind === 'base' ? 1.6 : 1;
    ctx.scale(s, s);
    ctx.fillStyle = 'rgba(10,8,6,.35)'; ctx.beginPath(); ctx.ellipse(0, 0, 50, 10, 0, 0, Math.PI * 2); ctx.fill();
    SG.draw.poly(ctx, [[-40, 0], [40, 0], [30, -14], [8, -24], [-12, -16], [-34, -12]], '#5b5650');
    SG.draw.caps(ctx, [[[-14, -10], [10, -40], 4, '#3a2a20'], [[12, -8], [-4, -34], 3.4, '#3a2a20']]);
    ctx.restore();
  }
  // 老虎：四足走路循環，出手時往前撲
  drawTiger(ctx, u) {
    const st = u._rs || (u._rs = { seq: u.animSeq, pounce: 0, ph: Math.random() * 6, px: u.x, py: u.y });
    const T = this.WS.time, moving = Math.hypot(u.x - st.px, u.y - st.py) > 0.3;
    st.ph += moving ? 0.32 : 0; st.px = u.x; st.py = u.y;
    if (st.seq !== u.animSeq) { st.seq = u.animSeq; if (u.anim === 'attack') st.pounce = T; }
    const pk = Math.max(0, 1 - (T - st.pounce) / 0.35), lunge = Math.sin(pk * Math.PI) * 16;
    const ink = SG.draw.ink, O = '#e48a2a', D = '#1e140c', W2 = '#f4ead6';
    ctx.save(); ctx.translate(u.x, u.y);
    SG.draw.castShadow(ctx, 0, 2, 48, 13, 60, 0.3); // 影子在翻轉之前畫，方向才跟太陽一致
    ctx.scale(u.f * 1.1, 1.1);
    ctx.translate(lunge, -Math.sin(pk * Math.PI) * 6);
    const leg = (x, ph, back) => {
      const sw = moving ? Math.sin(st.ph + ph) * 9 : 0;
      ctx.beginPath(); ctx.moveTo(x - 6, -30); ctx.lineTo(x + 6, -30); ctx.lineTo(x + 5 + sw, -2); ctx.lineTo(x - 5 + sw, -2); ctx.closePath(); ink(ctx, back ? '#b86a1e' : O, 2);
      ctx.beginPath(); ctx.ellipse(x + sw, -2, 7, 3.5, 0, 0, Math.PI * 2); ink(ctx, W2, 1.6);
    };
    leg(-22, 0, true); leg(18, Math.PI, true);
    // 尾巴
    const tw = Math.sin(T * 3 + st.ph) * 6;
    ctx.strokeStyle = D; ctx.lineWidth = 9; ctx.lineCap = 'round'; ctx.beginPath(); ctx.moveTo(-34, -36); ctx.quadraticCurveTo(-56, -40 + tw, -60, -58 + tw); ctx.stroke();
    ctx.strokeStyle = O; ctx.lineWidth = 6; ctx.stroke();
    // 身體與條紋
    ctx.beginPath(); ctx.ellipse(-4, -38, 36, 15, 0, 0, Math.PI * 2); ink(ctx, O, 2.2);
    ctx.fillStyle = W2; ctx.beginPath(); ctx.ellipse(-2, -28, 26, 6, 0, 0, Math.PI); ctx.fill();
    ctx.strokeStyle = D; ctx.lineWidth = 3.2; ctx.lineCap = 'round';
    for (const x of [-26, -16, -6, 4, 14]) { ctx.beginPath(); ctx.moveTo(x, -52); ctx.quadraticCurveTo(x + 4, -44, x - 1, -36); ctx.stroke(); }
    leg(-16, Math.PI, false); leg(24, 0, false);
    // 頭
    ctx.save(); ctx.translate(34, -46 + (moving ? Math.sin(st.ph * 2) * 1.5 : 0));
    for (const ex of [-9, 6]) { ctx.beginPath(); ctx.arc(ex, -13, 5.5, 0, Math.PI * 2); ink(ctx, O, 1.8); }
    ctx.beginPath(); ctx.ellipse(0, 0, 15, 13, 0, 0, Math.PI * 2); ink(ctx, O, 2.2);
    ctx.beginPath(); ctx.ellipse(8, 5, 9, 6.5, 0, 0, Math.PI * 2); ink(ctx, W2, 1.6);
    ctx.fillStyle = D; ctx.beginPath(); ctx.ellipse(14, 2, 3, 2.2, 0, 0, Math.PI * 2); ctx.fill();
    ctx.beginPath(); ctx.ellipse(4, -4, 2.2, 2.8, 0, 0, Math.PI * 2); ctx.fill();
    ctx.strokeStyle = D; ctx.lineWidth = 2.2; ctx.beginPath(); ctx.moveTo(-6, -11); ctx.lineTo(-2, -6); ctx.moveTo(-11, -4); ctx.lineTo(-5, -2); ctx.moveTo(-1, -12); ctx.lineTo(1, -7); ctx.stroke();
    if (pk > 0.2) { ctx.fillStyle = '#7a1e18'; ctx.beginPath(); ctx.moveTo(6, 8); ctx.lineTo(18, 7); ctx.lineTo(14, 13); ctx.closePath(); ctx.fill(); }
    ctx.restore();
    ctx.restore();
  }
  // 水式神：半透明的水柱人形，身體不停流動，腳下一圈漣漪；出手時往前湧
  // king：水精靈王——同一個水柱人形放大 1.6 倍，頂上一圈水冠、身邊環繞水珠
  drawWaterSpirit(ctx, u, king) {
    const st = u._rs || (u._rs = { seq: u.animSeq, hit: -9 });
    const T = this.WS.time;
    if (st.seq !== u.animSeq) { st.seq = u.animSeq; if (u.anim === 'attack') st.hit = T; }
    const pk = Math.max(0, 1 - (T - st.hit) / 0.3), surge = Math.sin(pk * Math.PI);
    ctx.save(); ctx.translate(u.x, u.y);
    if (king) ctx.scale(1.6, 1.6);
    // 腳下的水窪與漣漪
    ctx.fillStyle = 'rgba(40,110,170,.35)'; ctx.beginPath(); ctx.ellipse(0, 0, 34, 11, 0, 0, Math.PI * 2); ctx.fill();
    ctx.strokeStyle = 'rgba(190,235,255,.55)'; ctx.lineWidth = 1.6;
    for (let k = 0; k < 2; k++) { const q = (T * 0.8 + k * 0.5) % 1; ctx.globalAlpha = 1 - q; ctx.beginPath(); ctx.ellipse(0, 0, 18 + q * 30, (18 + q * 30) * 0.33, 0, 0, Math.PI * 2); ctx.stroke(); }
    ctx.globalAlpha = 1;
    ctx.scale(u.f, 1); ctx.translate(surge * 8, 0);
    // 身體：由下往上收窄的水柱，邊緣隨時間起伏
    const H = 78 + Math.sin(T * 2.2) * 3, wob = (y, k) => Math.sin(T * 4 + y * 0.12 + k) * 3;
    const body = ctx.createLinearGradient(0, -H, 0, 0);
    body.addColorStop(0, 'rgba(170,230,255,.9)'); body.addColorStop(0.55, 'rgba(70,160,230,.82)'); body.addColorStop(1, 'rgba(30,100,180,.7)');
    ctx.fillStyle = body; ctx.beginPath(); ctx.moveTo(-22, 0);
    for (let y = 0; y >= -H; y -= 8) { const w2 = 22 - (y / -H) * 8; ctx.lineTo(-w2 + wob(y, 0), y); }
    ctx.quadraticCurveTo(0, -H - 22, 14 + wob(-H, 1), -H);
    for (let y = -H; y <= 0; y += 8) { const w2 = 22 - (y / -H) * 8; ctx.lineTo(w2 + wob(y, 2), y); }
    ctx.closePath(); ctx.fill();
    ctx.strokeStyle = 'rgba(20,60,110,.6)'; ctx.lineWidth = 2; ctx.stroke();
    // 手臂：出手時往前伸
    ctx.strokeStyle = 'rgba(90,180,240,.85)'; ctx.lineWidth = 9; ctx.lineCap = 'round';
    ctx.beginPath(); ctx.moveTo(10, -H * 0.62); ctx.quadraticCurveTo(26 + surge * 14, -H * 0.55, 30 + surge * 22, -H * 0.42 - surge * 6); ctx.stroke();
    ctx.beginPath(); ctx.moveTo(-10, -H * 0.62); ctx.quadraticCurveTo(-24, -H * 0.5, -22, -H * 0.36); ctx.stroke();
    // 流動的亮紋與眼睛
    ctx.strokeStyle = 'rgba(235,250,255,.7)'; ctx.lineWidth = 2;
    for (let k = 0; k < 3; k++) { const y0 = -((T * 40 + k * 26) % H); ctx.beginPath(); ctx.moveTo(-8, y0); ctx.quadraticCurveTo(0, y0 - 6, 8, y0 - 2); ctx.stroke(); }
    ctx.fillStyle = '#eaffff'; for (const ex of [-5, 7]) { ctx.beginPath(); ctx.ellipse(ex, -H + 10, 3, 4, 0, 0, Math.PI * 2); ctx.fill(); }
    // 頂上的水花
    ctx.fillStyle = 'rgba(200,240,255,.8)';
    for (let k = 0; k < 4; k++) { const a = T * 3 + k * 1.6, q = (T * 1.5 + k * 0.25) % 1; ctx.globalAlpha = 1 - q; ctx.beginPath(); ctx.arc(Math.cos(a) * 10, -H - 10 - q * 16, 2.4, 0, Math.PI * 2); ctx.fill(); }
    ctx.globalAlpha = 1;
    if (king) {
      // 水冠：五根往上翹的水尖，中間一顆發亮的水珠
      ctx.fillStyle = 'rgba(200,245,255,.92)'; ctx.strokeStyle = 'rgba(20,70,130,.7)'; ctx.lineWidth = 1.4;
      ctx.beginPath(); ctx.moveTo(-13, -H + 2);
      for (let k = 0; k < 5; k++) { const x = -13 + k * 6.5, h = (k === 2 ? 15 : k % 2 ? 9 : 11) + Math.sin(T * 5 + k) * 1.5; ctx.lineTo(x + 3.2, -H - h); ctx.lineTo(x + 6.5, -H + 2); }
      ctx.closePath(); ctx.fill(); ctx.stroke();
      ctx.fillStyle = '#ffffff'; ctx.beginPath(); ctx.arc(0, -H - 4, 2.6, 0, Math.PI * 2); ctx.fill();
      // 環繞的水珠
      for (let k = 0; k < 6; k++) {
        const a = T * 1.6 + (k / 6) * Math.PI * 2, x = Math.cos(a) * 30, y = -H * 0.5 + Math.sin(a) * 9;
        ctx.globalAlpha = Math.sin(a) > 0 ? 0.95 : 0.45; ctx.fillStyle = 'rgba(150,220,255,.9)';
        ctx.beginPath(); ctx.arc(x, y, 3.2, 0, Math.PI * 2); ctx.fill();
      }
      ctx.globalAlpha = 1;
    }
    ctx.restore();
  }
  // 召喚物共用的動作狀態：有沒有在走、最近一次出手（0～1 的衝刺曲線）
  beastState(u, dur) {
    const st = u._rs || (u._rs = { seq: u.animSeq, hit: -9, ph: Math.random() * 6, px: u.x, py: u.y });
    const T = this.WS.time, moving = Math.hypot(u.x - st.px, u.y - st.py) > 0.3;
    st.ph += moving ? 0.25 : 0; st.px = u.x; st.py = u.y;
    if (st.seq !== u.animSeq) { st.seq = u.animSeq; if (u.anim === 'attack') st.hit = T; }
    const pk = Math.max(0, 1 - (T - st.hit) / (dur || 0.35));
    return { st, T, moving, hit: Math.sin(pk * Math.PI), team: u.team === 0 ? '#c9a24e' : u.team === 1 ? '#6a7ad8' : '#9a9a9a' };
  }
  // 曹洪「靈僕」：飄在半空的紫色鬼火，腳下一圈燒人的鬼火環
  drawSpirit(ctx, u) {
    const { st, T, hit } = this.beastState(u), ink = SG.draw.ink;
    ctx.save(); ctx.translate(u.x, u.y);
    ctx.strokeStyle = 'rgba(180,140,255,.35)'; ctx.lineWidth = 1.5; ctx.setLineDash([4, 6]); ctx.lineDashOffset = -T * 30;
    ctx.beginPath(); ctx.ellipse(0, 0, 120, 120 * SG.K, 0, 0, Math.PI * 2); ctx.stroke(); ctx.setLineDash([]);
    for (let k = 0; k < 6; k++) { const a = T * 1.4 + k * 1.05; ctx.fillStyle = `rgba(190,150,255,${0.35 + 0.25 * Math.sin(T * 6 + k)})`; ctx.beginPath(); ctx.ellipse(Math.cos(a) * 110, Math.sin(a) * 110 * SG.K - 5, 4, 9, 0, 0, Math.PI * 2); ctx.fill(); }
    ctx.fillStyle = 'rgba(30,20,50,.3)'; ctx.beginPath(); ctx.ellipse(0, 0, 18, 6, 0, 0, Math.PI * 2); ctx.fill();
    ctx.scale(u.f, 1);
    const fy = -48 + Math.sin(T * 2.6 + st.ph) * 5;
    ctx.translate(hit * 10, fy);
    ctx.globalCompositeOperation = 'lighter';
    const g = ctx.createRadialGradient(0, 0, 2, 0, 0, 34); g.addColorStop(0, 'rgba(200,170,255,.55)'); g.addColorStop(1, 'rgba(120,60,220,0)');
    ctx.fillStyle = g; ctx.beginPath(); ctx.arc(0, 0, 34, 0, Math.PI * 2); ctx.fill();
    ctx.globalCompositeOperation = 'source-over';
    // 身體：往上飄的火焰形，尾巴拖在後面
    const wv = (k) => Math.sin(T * 7 + k) * 3;
    ctx.beginPath(); ctx.moveTo(-14, 6); ctx.quadraticCurveTo(-18, -10, -6 + wv(1), -24); ctx.quadraticCurveTo(0, -36 + wv(2), 4 + wv(3), -22);
    ctx.quadraticCurveTo(16, -10, 13, 6); ctx.quadraticCurveTo(4, 16, -6, 12 + wv(4)); ctx.quadraticCurveTo(-22, 22, -28 + wv(5), 14); ctx.quadraticCurveTo(-18, 12, -14, 6); ctx.closePath();
    const bg = ctx.createLinearGradient(0, -36, 0, 18); bg.addColorStop(0, '#e8d8ff'); bg.addColorStop(0.5, '#a070ff'); bg.addColorStop(1, '#4a2290');
    ink(ctx, bg, 1.8);
    ctx.fillStyle = '#ffffff'; for (const ex of [-3, 6]) { ctx.beginPath(); ctx.ellipse(ex, -6, 2.4, 3.6, 0, 0, Math.PI * 2); ctx.fill(); }
    ctx.fillStyle = '#2a1050'; ctx.beginPath(); ctx.ellipse(1.5, 3, 3, 2 + hit * 2, 0, 0, Math.PI * 2); ctx.fill();
    ctx.restore();
  }
  // 賈詡「屍兵」：駝背、灰綠皮膚、破甲、眼睛發綠光，拖著腳走，出手時往前撲
  drawZombie(ctx, u) {
    const { st, T, moving, hit, team } = this.beastState(u, 0.4), ink = SG.draw.ink, SK = '#8f9e7e', AR = '#5a5048';
    ctx.save(); ctx.translate(u.x, u.y);
    SG.draw.castShadow(ctx, 0, 2, 22, 7, 40, 0.3);
    ctx.scale(u.f * 0.95, 0.95);
    const sw = moving ? Math.sin(st.ph * 0.8) : 0;
    const leg = (x, p) => { const o = sw * p * 7; ctx.beginPath(); ctx.moveTo(x - 4, -36); ctx.lineTo(x + 4, -36); ctx.lineTo(x + 4 + o, -2); ctx.lineTo(x - 4 + o, -2); ctx.closePath(); ink(ctx, '#4a4038', 1.6); };
    leg(-6, 1); leg(6, -1);
    ctx.save(); ctx.translate(hit * 10, 0); ctx.rotate(0.28 + hit * 0.2 + (moving ? Math.sin(st.ph * 1.6) * 0.04 : 0));
    ctx.beginPath(); ctx.moveTo(-12, -36); ctx.lineTo(12, -36); ctx.lineTo(10, -70); ctx.lineTo(-11, -68); ctx.closePath(); ink(ctx, AR, 1.8); // 破甲
    ctx.strokeStyle = '#2a2420'; ctx.lineWidth = 1.2; ctx.beginPath(); ctx.moveTo(-8, -48); ctx.lineTo(-2, -56); ctx.moveTo(4, -44); ctx.lineTo(8, -54); ctx.stroke();
    ctx.fillStyle = team; ctx.fillRect(-12, -40, 24, 3); // 生前的軍帶（己方顏色）
    // 往前伸的手
    const reach = 18 + hit * 12;
    ctx.strokeStyle = '#2a2420'; ctx.lineWidth = 7; ctx.lineCap = 'round'; ctx.beginPath(); ctx.moveTo(6, -64); ctx.lineTo(6 + reach, -60 + Math.sin(T * 3) * 2); ctx.stroke();
    ctx.strokeStyle = SK; ctx.lineWidth = 5; ctx.stroke();
    ctx.strokeStyle = '#2a2420'; ctx.lineWidth = 7; ctx.beginPath(); ctx.moveTo(-4, -64); ctx.lineTo(-2 + reach * 0.8, -55 + Math.sin(T * 3 + 1) * 2); ctx.stroke();
    ctx.strokeStyle = SK; ctx.lineWidth = 5; ctx.stroke();
    // 頭：歪一邊、散髮、綠眼
    ctx.save(); ctx.translate(4, -78); ctx.rotate(-0.25 + Math.sin(T * 1.3 + st.ph) * 0.08);
    ctx.beginPath(); ctx.ellipse(0, 0, 10, 11, 0, 0, Math.PI * 2); ink(ctx, SK, 1.6);
    ctx.strokeStyle = '#1e1a16'; ctx.lineWidth = 2; for (const x of [-8, -4, 0]) { ctx.beginPath(); ctx.moveTo(x, -9); ctx.lineTo(x - 3, 6); ctx.stroke(); }
    ctx.fillStyle = '#9dff6a'; ctx.shadowColor = '#9dff6a'; ctx.shadowBlur = 6; for (const ex of [2, 7]) { ctx.beginPath(); ctx.arc(ex, -1, 1.8, 0, Math.PI * 2); ctx.fill(); }
    ctx.shadowBlur = 0; ctx.fillStyle = '#2a1a14'; ctx.fillRect(2, 5, 6, 2 + hit * 2);
    ctx.restore(); ctx.restore(); ctx.restore();
  }
  // 賈詡「肉傀儡」：縫合的肉塊巨人，一手肉鉤；出手時舉手往下砸
  drawGolem(ctx, u) {
    const { st, T, moving, hit } = this.beastState(u, 0.5), ink = SG.draw.ink, F = '#b8735e', FD = '#8a4e3e';
    ctx.save(); ctx.translate(u.x, u.y);
    SG.draw.castShadow(ctx, 0, 2, 44, 13, 60, 0.32);
    ctx.scale(u.f, 1);
    const sw = moving ? Math.sin(st.ph * 0.7) : 0, bob = moving ? Math.abs(Math.sin(st.ph * 0.7)) * 3 : 0;
    const leg = (x, p) => { const o = sw * p * 8; ctx.beginPath(); ctx.moveTo(x - 10, -40); ctx.lineTo(x + 10, -40); ctx.lineTo(x + 11 + o, -3); ctx.lineTo(x - 11 + o, -3); ctx.closePath(); ink(ctx, FD, 2.2); };
    leg(-14, 1); leg(14, -1);
    ctx.translate(0, -bob);
    ctx.beginPath(); ctx.ellipse(0, -78, 40, 42, 0, 0, Math.PI * 2); ink(ctx, F, 2.6); // 肚子
    ctx.fillStyle = FD; for (const [x, y, r] of [[-18, -96, 9], [16, -64, 11], [-8, -58, 7]]) { ctx.globalAlpha = 0.45; ctx.beginPath(); ctx.arc(x, y, r, 0, Math.PI * 2); ctx.fill(); }
    ctx.globalAlpha = 1;
    ctx.strokeStyle = '#3a1e18'; ctx.lineWidth = 1.6; // 縫線
    for (const [x0, y0, x1, y1] of [[-26, -100, 6, -90], [-10, -70, 26, -78], [-30, -62, -6, -48]]) {
      ctx.beginPath(); ctx.moveTo(x0, y0); ctx.lineTo(x1, y1); ctx.stroke();
      for (let k = 1; k < 5; k++) { const x = x0 + (x1 - x0) * k / 5, y = y0 + (y1 - y0) * k / 5; ctx.beginPath(); ctx.moveTo(x - 2, y - 4); ctx.lineTo(x + 2, y + 4); ctx.stroke(); }
    }
    // 小小的頭
    ctx.beginPath(); ctx.ellipse(10, -124, 12, 11, 0, 0, Math.PI * 2); ink(ctx, F, 2);
    ctx.fillStyle = '#ffde5a'; for (const ex of [8, 15]) { ctx.beginPath(); ctx.arc(ex, -126, 2, 0, Math.PI * 2); ctx.fill(); }
    ctx.fillStyle = '#3a1410'; ctx.fillRect(8, -119, 8, 2);
    // 後手
    ctx.strokeStyle = '#3a1e18'; ctx.lineWidth = 14; ctx.lineCap = 'round'; ctx.beginPath(); ctx.moveTo(-30, -96); ctx.lineTo(-40, -60 + Math.sin(T * 2) * 3); ctx.stroke(); ctx.strokeStyle = FD; ctx.lineWidth = 11; ctx.stroke();
    // 前手：肉鉤，出手時舉起往下砸
    const ang = -0.4 - hit * 1.6, hx = 30 + Math.cos(ang) * 38, hy = -96 + Math.sin(ang) * 38 + 38;
    ctx.strokeStyle = '#3a1e18'; ctx.lineWidth = 15; ctx.beginPath(); ctx.moveTo(28, -98); ctx.lineTo(hx, hy); ctx.stroke(); ctx.strokeStyle = F; ctx.lineWidth = 12; ctx.stroke();
    ctx.strokeStyle = '#2a2622'; ctx.lineWidth = 4; ctx.beginPath(); ctx.moveTo(hx, hy); ctx.lineTo(hx + 4, hy + 16); ctx.stroke();
    ctx.strokeStyle = '#c8ccd2'; ctx.lineWidth = 3.2; ctx.beginPath(); ctx.arc(hx + 10, hy + 18, 7, Math.PI, Math.PI * 0.2, true); ctx.stroke();
    ctx.restore();
  }
  // 于禁「木精召喚」：紮根的小樹精，樹冠隨風晃，雙眼發綠光；出手時枝臂往前一甩
  drawTreant(ctx, u) {
    const { st, T, hit } = this.beastState(u, 0.3), ink = SG.draw.ink, B = '#7a5636', BD = '#4e3420', L = '#5fa84a', LD = '#3d7a30';
    ctx.save(); ctx.translate(u.x, u.y);
    SG.draw.castShadow(ctx, 0, 2, 30, 10, 60, 0.3);
    ctx.scale(u.f, 1);
    ctx.strokeStyle = BD; ctx.lineWidth = 4; ctx.lineCap = 'round'; // 樹根
    for (const [x, d] of [[-10, -1], [-2, -0.4], [8, 1]]) { ctx.beginPath(); ctx.moveTo(x, -8); ctx.quadraticCurveTo(x + d * 10, -2, x + d * 18, 2); ctx.stroke(); }
    ctx.beginPath(); ctx.moveTo(-13, -4); ctx.lineTo(-10, -64); ctx.lineTo(10, -64); ctx.lineTo(13, -4); ctx.closePath(); ink(ctx, B, 2); // 樹幹
    ctx.strokeStyle = BD; ctx.lineWidth = 1.4; for (const x of [-5, 4]) { ctx.beginPath(); ctx.moveTo(x, -10); ctx.lineTo(x + 1, -56); ctx.stroke(); }
    ctx.fillStyle = '#b6ff7a'; ctx.shadowColor = '#b6ff7a'; ctx.shadowBlur = 6; // 眼睛
    for (const ex of [-4, 5]) { ctx.beginPath(); ctx.arc(ex, -44, 2.2, 0, Math.PI * 2); ctx.fill(); }
    ctx.shadowBlur = 0;
    const ang = -0.9 + hit * 1.3, ax = 10 + Math.cos(ang) * 30, ay = -50 + Math.sin(ang) * 30; // 枝臂
    ctx.strokeStyle = BD; ctx.lineWidth = 6; ctx.beginPath(); ctx.moveTo(8, -50); ctx.lineTo(ax, ay); ctx.stroke();
    ctx.strokeStyle = B; ctx.lineWidth = 4; ctx.stroke();
    ctx.beginPath(); ctx.arc(ax, ay, 6, 0, Math.PI * 2); ink(ctx, L, 1.4);
    const sway = Math.sin(T * 1.6 + st.ph) * 3; // 樹冠
    for (const [x, y, r, c] of [[-14, -74, 16, LD], [14, -76, 15, LD], [0, -88, 19, L], [-8, -70, 12, L], [9, -71, 12, L]]) { ctx.beginPath(); ctx.arc(x + sway * (y < -80 ? 1 : 0.6), y, r, 0, Math.PI * 2); ink(ctx, c, 1.6); }
    ctx.restore();
  }
  // 荀彧「蛇形結界」：石座上盤成一圈的蛇，頭左右晃，出手時往前咬
  drawSnakeWard(ctx, u) {
    const { st, T, hit } = this.beastState(u, 0.3), ink = SG.draw.ink, G = '#4f8f3e', GD = '#2f5e26';
    ctx.save(); ctx.translate(u.x, u.y);
    SG.draw.castShadow(ctx, 0, 2, 24, 8, 30, 0.3);
    ctx.scale(u.f, 1);
    ctx.beginPath(); ctx.ellipse(0, -4, 22, 9, 0, 0, Math.PI * 2); ink(ctx, '#8a8478', 1.8); // 石座
    ctx.fillStyle = '#6f6a60'; ctx.fillRect(-22, -4, 44, 4);
    for (let k = 2; k >= 0; k--) { // 盤起來的身體（由下往上縮小）
      const y = -10 - k * 9, w = 18 - k * 4;
      ctx.beginPath(); ctx.ellipse(0, y, w, 6, 0, 0, Math.PI * 2); ink(ctx, k % 2 ? GD : G, 1.6);
      ctx.fillStyle = '#d8c060'; for (let j = -1; j <= 1; j++) { ctx.beginPath(); ctx.arc(j * w * 0.5, y + 1, 1.6, 0, Math.PI * 2); ctx.fill(); }
    }
    // 脖子：S 形往上，出手時往前伸
    const sway = Math.sin(T * 2.2 + st.ph) * 5, lx = 10 + hit * 26 + sway, ly = -62 + hit * 10;
    ctx.strokeStyle = '#1e3a18'; ctx.lineWidth = 10; ctx.lineCap = 'round';
    ctx.beginPath(); ctx.moveTo(0, -36); ctx.bezierCurveTo(-12, -48, 14 + sway, -52, lx, ly); ctx.stroke();
    ctx.strokeStyle = G; ctx.lineWidth = 7.5; ctx.stroke();
    ctx.save(); ctx.translate(lx, ly); ctx.rotate(hit * 0.3);
    ctx.beginPath(); ctx.moveTo(-6, -6); ctx.quadraticCurveTo(10, -9, 14, -1); ctx.quadraticCurveTo(10, 6, -6, 5); ctx.closePath(); ink(ctx, G, 1.6);
    ctx.fillStyle = '#c070ff'; ctx.shadowColor = '#c070ff'; ctx.shadowBlur = 5; ctx.beginPath(); ctx.arc(4, -3, 1.8, 0, Math.PI * 2); ctx.fill(); ctx.shadowBlur = 0;
    if (hit > 0.2) { ctx.fillStyle = '#ffffff'; ctx.beginPath(); ctx.moveTo(10, 1); ctx.lineTo(12, 6); ctx.lineTo(13, 1); ctx.fill(); }
    ctx.strokeStyle = '#d0303a'; ctx.lineWidth = 1.2; const tf = Math.sin(T * 12) > 0 ? 5 : 2; ctx.beginPath(); ctx.moveTo(14, 0); ctx.lineTo(14 + tf, -1); ctx.moveTo(14 + tf, -1); ctx.lineTo(17 + tf, -3); ctx.moveTo(14 + tf, -1); ctx.lineTo(17 + tf, 1); ctx.stroke();
    ctx.restore(); ctx.restore();
  }
  // 郝昭「箭樓」：四腳木架、平台、小屋頂、插己方旗，弓手探頭；射箭時弓閃一下
  drawArrowTower(ctx, u) {
    const { T, hit, team } = this.beastState(u, 0.25), ink = SG.draw.ink, W = '#8a6238', WD = '#5a3e22';
    ctx.save(); ctx.translate(u.x, u.y);
    SG.draw.castShadow(ctx, 0, 2, 30, 10, 70, 0.32);
    ctx.scale(u.f, 1);
    ctx.strokeStyle = WD; ctx.lineWidth = 5; ctx.lineCap = 'round';
    for (const x of [-18, 18]) { ctx.beginPath(); ctx.moveTo(x, 0); ctx.lineTo(x * 0.7, -76); ctx.stroke(); }
    ctx.lineWidth = 3; ctx.beginPath(); ctx.moveTo(-17, -10); ctx.lineTo(12, -66); ctx.moveTo(17, -10); ctx.lineTo(-12, -66); ctx.moveTo(-16, -38); ctx.lineTo(16, -38); ctx.stroke();
    ctx.beginPath(); ctx.rect(-20, -96, 40, 20); ink(ctx, W, 2); // 平台與擋板
    ctx.strokeStyle = WD; ctx.lineWidth = 1.4; for (const x of [-10, 0, 10]) { ctx.beginPath(); ctx.moveTo(x, -96); ctx.lineTo(x, -76); ctx.stroke(); }
    // 弓手
    ctx.beginPath(); ctx.arc(4, -102, 6, 0, Math.PI * 2); ink(ctx, '#e2b48c', 1.4);
    ctx.fillStyle = '#3a3a40'; ctx.beginPath(); ctx.moveTo(-3, -104); ctx.lineTo(11, -104); ctx.lineTo(4, -112); ctx.closePath(); ctx.fill();
    ctx.strokeStyle = hit > 0.3 ? '#ffe28a' : '#4a2e18'; ctx.lineWidth = 2; ctx.beginPath(); ctx.arc(14, -100, 7, -1.2, 1.2); ctx.stroke();
    // 屋頂
    ctx.beginPath(); ctx.moveTo(-26, -112); ctx.lineTo(26, -112); ctx.lineTo(16, -126); ctx.lineTo(-16, -126); ctx.closePath(); ink(ctx, '#4a4a52', 1.8);
    // 旗
    ctx.strokeStyle = '#3a2a1a'; ctx.lineWidth = 2; ctx.beginPath(); ctx.moveTo(-14, -126); ctx.lineTo(-14, -146); ctx.stroke();
    const fw = Math.sin(T * 5 + u.id) * 2.5; ctx.beginPath(); ctx.moveTo(-14, -146); ctx.quadraticCurveTo(-4, -144 + fw, 4, -142); ctx.lineTo(-14, -136); ctx.closePath(); ink(ctx, team, 1.2);
    ctx.restore();
  }
  // 曹純「虎豹騎」：披甲黑馬、重甲騎士持矛，奔跑時四蹄交錯，出手時把矛往前刺
  drawHubao(ctx, u) {
    const { st, T, moving, hit, team } = this.beastState(u, 0.35), ink = SG.draw.ink, H = '#2e2620', HB = '#5a5a62', AR = '#6a6f7c';
    ctx.save(); ctx.translate(u.x, u.y);
    SG.draw.castShadow(ctx, 0, 2, 40, 11, 55, 0.3);
    ctx.scale(u.f, 1);
    const gal = moving ? st.ph * 1.4 : 0, bob = moving ? Math.abs(Math.sin(gal)) * 3 : 0;
    const leg = (x, p, back) => { const a = moving ? Math.sin(gal + p) * 0.6 : 0; ctx.save(); ctx.translate(x, -34); ctx.rotate(a); ctx.beginPath(); ctx.moveTo(-3.5, 0); ctx.lineTo(3.5, 0); ctx.lineTo(3, 32); ctx.lineTo(-3, 32); ctx.closePath(); ink(ctx, back ? '#1e1814' : H, 1.4); ctx.restore(); };
    leg(-20, 0, true); leg(18, Math.PI, true);
    ctx.translate(0, -bob);
    // 馬身與馬甲
    ctx.beginPath(); ctx.ellipse(0, -44, 30, 13, 0, 0, Math.PI * 2); ink(ctx, H, 2);
    ctx.beginPath(); ctx.moveTo(-26, -50); ctx.lineTo(24, -50); ctx.lineTo(22, -34); ctx.lineTo(-24, -34); ctx.closePath(); ink(ctx, HB, 1.6);
    ctx.strokeStyle = '#2a2a30'; ctx.lineWidth = 1; for (let x = -20; x <= 18; x += 6) { ctx.beginPath(); ctx.moveTo(x, -50); ctx.lineTo(x, -34); ctx.stroke(); }
    // 馬頸、馬頭
    ctx.beginPath(); ctx.moveTo(20, -52); ctx.lineTo(34, -72); ctx.lineTo(42, -68); ctx.lineTo(30, -44); ctx.closePath(); ink(ctx, H, 1.8);
    ctx.beginPath(); ctx.ellipse(44, -68, 10, 6, 0.5, 0, Math.PI * 2); ink(ctx, H, 1.6);
    ctx.fillStyle = HB; ctx.beginPath(); ctx.moveTo(34, -74); ctx.lineTo(48, -72); ctx.lineTo(46, -66); ctx.lineTo(36, -68); ctx.closePath(); ctx.fill(); // 面簾
    ctx.strokeStyle = '#1a1410'; ctx.lineWidth = 3; ctx.beginPath(); ctx.moveTo(28, -72); ctx.quadraticCurveTo(22, -66 + Math.sin(T * 8) * 2, 18, -58); ctx.stroke(); // 鬃毛
    ctx.strokeStyle = '#1e1814'; ctx.lineWidth = 4; ctx.beginPath(); ctx.moveTo(-30, -46); ctx.quadraticCurveTo(-42, -40 + Math.sin(T * 5) * 3, -40, -26); ctx.stroke(); // 尾
    leg(-14, Math.PI, false); leg(22, 0, false);
    // 騎士
    ctx.beginPath(); ctx.moveTo(-8, -56); ctx.lineTo(8, -56); ctx.lineTo(6, -84); ctx.lineTo(-6, -84); ctx.closePath(); ink(ctx, AR, 1.6);
    ctx.fillStyle = team; ctx.fillRect(-6, -70, 12, 3);
    ctx.beginPath(); ctx.arc(0, -92, 7, 0, Math.PI * 2); ink(ctx, '#e2b48c', 1.4);
    ctx.beginPath(); ctx.moveTo(-8, -92); ctx.lineTo(8, -92); ctx.lineTo(5, -102); ctx.lineTo(-5, -102); ctx.closePath(); ink(ctx, AR, 1.4); // 盔
    ctx.strokeStyle = '#c0302a'; ctx.lineWidth = 2.5; ctx.beginPath(); ctx.moveTo(0, -102); ctx.quadraticCurveTo(-6, -110, -12, -106 + Math.sin(T * 6) * 2); ctx.stroke(); // 盔纓
    // 長矛：平舉，出手時往前刺
    const sx = hit * 22;
    ctx.strokeStyle = '#4a321c'; ctx.lineWidth = 3; ctx.beginPath(); ctx.moveTo(-18 + sx, -74); ctx.lineTo(48 + sx, -80); ctx.stroke();
    ctx.beginPath(); ctx.moveTo(48 + sx, -83); ctx.lineTo(60 + sx, -81); ctx.lineTo(48 + sx, -77); ctx.closePath(); ink(ctx, '#d8dde3', 1.2);
    ctx.restore();
  }
  // 戰象：灰色巨象、背上紅毯與木製象轎（插己方旗），出手時抬鼻往前頂
  drawElephant(ctx, u) {
    const st = u._rs || (u._rs = { seq: u.animSeq, hit: -9, ph: Math.random() * 6, px: u.x, py: u.y });
    const T = this.WS.time, moving = Math.hypot(u.x - st.px, u.y - st.py) > 0.3;
    st.ph += moving ? 0.2 : 0; st.px = u.x; st.py = u.y;
    if (st.seq !== u.animSeq) { st.seq = u.animSeq; if (u.anim === 'attack') st.hit = T; }
    const pk = Math.max(0, 1 - (T - st.hit) / 0.45), ram = Math.sin(pk * Math.PI);
    const ink = SG.draw.ink, G = '#8e8a86', GD = '#6c6864', GL = '#aaa6a1', TUSK = '#f3ead6', TEAM = u.team === 0 ? '#c9a24e' : u.team === 1 ? '#6a7ad8' : '#9a9a9a';
    ctx.save(); ctx.translate(u.x, u.y);
    SG.draw.castShadow(ctx, 0, 2, 66, 16, 80, 0.32);
    ctx.scale(u.f, 1);
    ctx.translate(ram * 12, 0);
    const bob = moving ? Math.abs(Math.sin(st.ph)) * 2 : 0;
    const leg = (x, ph, back) => {
      const sw = moving ? Math.sin(st.ph + ph) * 7 : 0;
      ctx.beginPath(); ctx.moveTo(x - 9, -48); ctx.lineTo(x + 9, -48); ctx.lineTo(x + 9 + sw, -4); ctx.lineTo(x - 9 + sw, -4); ctx.closePath(); ink(ctx, back ? GD : G, 2.2);
      ctx.beginPath(); ctx.ellipse(x + sw, -3, 10, 4, 0, 0, Math.PI * 2); ink(ctx, back ? '#5c5854' : GD, 1.6);
      ctx.fillStyle = TUSK; for (const t of [-5, 0, 5]) { ctx.beginPath(); ctx.arc(x + sw + t, -3, 1.6, 0, Math.PI * 2); ctx.fill(); }
    };
    leg(-30, 0, true); leg(22, Math.PI, true);
    ctx.translate(0, -bob);
    // 尾巴
    ctx.strokeStyle = GD; ctx.lineWidth = 3; ctx.lineCap = 'round';
    ctx.beginPath(); ctx.moveTo(-52, -66); ctx.quadraticCurveTo(-62, -52 + Math.sin(T * 3) * 3, -60, -40); ctx.stroke();
    // 身體
    ctx.beginPath(); ctx.ellipse(-6, -66, 50, 30, 0, 0, Math.PI * 2); ink(ctx, G, 2.4);
    ctx.fillStyle = GL; ctx.globalAlpha = 0.5; ctx.beginPath(); ctx.ellipse(-12, -80, 34, 10, -0.1, 0, Math.PI * 2); ctx.fill(); ctx.globalAlpha = 1;
    // 紅毯（金邊）與象轎
    ctx.beginPath(); ctx.moveTo(-32, -92); ctx.lineTo(18, -92); ctx.lineTo(22, -62); ctx.lineTo(-36, -62); ctx.closePath(); ink(ctx, '#a8322a', 2);
    ctx.strokeStyle = '#e9c46a'; ctx.lineWidth = 2.4; ctx.beginPath(); ctx.moveTo(-35, -65); ctx.lineTo(21, -65); ctx.stroke();
    for (const x of [-28, -16, -4, 8, 18]) { ctx.fillStyle = '#e9c46a'; ctx.beginPath(); ctx.arc(x, -60, 2, 0, Math.PI * 2); ctx.fill(); }
    ctx.beginPath(); ctx.rect(-24, -116, 34, 24); ink(ctx, '#7a5530', 2);
    ctx.strokeStyle = '#4a321c'; ctx.lineWidth = 1.6; for (const x of [-16, -7, 2]) { ctx.beginPath(); ctx.moveTo(x, -116); ctx.lineTo(x, -92); ctx.stroke(); }
    ctx.beginPath(); ctx.moveTo(-28, -116); ctx.lineTo(14, -116); ctx.lineTo(8, -124); ctx.lineTo(-22, -124); ctx.closePath(); ink(ctx, '#5a3a22', 1.8);
    // 己方旗
    ctx.strokeStyle = '#3a2a1a'; ctx.lineWidth = 2; ctx.beginPath(); ctx.moveTo(-20, -124); ctx.lineTo(-20, -150); ctx.stroke();
    const fw = Math.sin(T * 4 + st.ph) * 3;
    ctx.beginPath(); ctx.moveTo(-20, -150); ctx.quadraticCurveTo(-8, -148 + fw, 2, -146); ctx.lineTo(-20, -138); ctx.closePath(); ink(ctx, TEAM, 1.4);
    leg(-22, Math.PI, false); leg(30, 0, false);
    // 頭、耳朵、象牙、象鼻
    ctx.save(); ctx.translate(42, -74 + (moving ? Math.sin(st.ph * 2) * 1.2 : 0)); ctx.rotate(-ram * 0.15);
    ctx.beginPath(); ctx.ellipse(-12, 2, 16, 22, -0.15, 0, Math.PI * 2); ink(ctx, GD, 2); // 耳朵
    ctx.beginPath(); ctx.ellipse(4, -2, 20, 19, 0, 0, Math.PI * 2); ink(ctx, G, 2.2);
    ctx.fillStyle = '#1e1a16'; ctx.beginPath(); ctx.ellipse(10, -6, 2.4, 3, 0, 0, Math.PI * 2); ctx.fill();
    // 象鼻：平常垂下輕晃，出手時往前上方甩
    const lift = ram, sway = Math.sin(T * 2 + st.ph) * 3;
    const tx = 30 + lift * 18, ty = 34 - lift * 52;
    ctx.strokeStyle = '#2a2622'; ctx.lineWidth = 13; ctx.lineCap = 'round';
    ctx.beginPath(); ctx.moveTo(18, 6); ctx.quadraticCurveTo(30 + sway, 18 - lift * 20, tx + sway, ty); ctx.stroke();
    ctx.strokeStyle = G; ctx.lineWidth = 10; ctx.stroke();
    ctx.strokeStyle = GD; ctx.lineWidth = 1.2; for (let k = 1; k < 5; k++) { const q = k / 5, x = 18 + (tx - 18) * q + sway * q, y = 6 + (ty - 6) * q; ctx.beginPath(); ctx.moveTo(x - 4, y); ctx.lineTo(x + 4, y + 1); ctx.stroke(); }
    // 象牙
    ctx.beginPath(); ctx.moveTo(14, 10); ctx.quadraticCurveTo(30, 18, 36, 6); ctx.quadraticCurveTo(28, 14, 16, 14); ctx.closePath(); ink(ctx, TUSK, 1.4);
    ctx.restore();
    ctx.restore();
  }
  // 貓頭鷹：在空中拍翅盤旋，地上留影子
  drawOwl(ctx, u) {
    const T = this.WS.time, arrived = Math.hypot(u.fly[0] - u.x, u.fly[1] - u.y) < 2;
    const ox = arrived ? Math.cos(T * 1.2 + u.id) * 34 : 0, oy = arrived ? Math.sin(T * 1.2 + u.id) * 14 : 0;
    const h = 130 + Math.sin(T * 2.4) * 8, flap = Math.sin(T * (arrived ? 9 : 14));
    const ink = SG.draw.ink, B = '#7a5a3a', L = '#c9a878';
    ctx.save(); ctx.translate(u.x + ox, u.y + oy);
    // 飛得越高，影子越往右下偏、越淡
    const sh = h * SG.SUN.len * 0.5;
    ctx.fillStyle = 'rgba(0,0,0,.18)'; ctx.beginPath(); ctx.ellipse(Math.cos(SG.SUN.ang) * sh, Math.sin(SG.SUN.ang) * sh * SG.K, 20, 6, 0, 0, Math.PI * 2); ctx.fill();
    ctx.translate(0, -h); ctx.scale(u.f, 1);
    for (const s of [-1, 1]) {
      ctx.beginPath(); ctx.moveTo(s * 6, -4); ctx.quadraticCurveTo(s * 30, -20 - flap * 16, s * 44, -6 - flap * 22); ctx.quadraticCurveTo(s * 28, 4 + flap * 4, s * 6, 8); ctx.closePath(); ink(ctx, s < 0 ? '#5f4429' : B, 2);
    }
    ctx.beginPath(); ctx.ellipse(0, 4, 13, 17, 0, 0, Math.PI * 2); ink(ctx, B, 2.2);
    ctx.fillStyle = L; ctx.beginPath(); ctx.ellipse(0, 9, 8, 10, 0, 0, Math.PI * 2); ctx.fill();
    ctx.beginPath(); ctx.moveTo(-10, -18); ctx.lineTo(-7, -26); ctx.lineTo(-3, -16); ctx.moveTo(10, -18); ctx.lineTo(7, -26); ctx.lineTo(3, -16); ink(ctx, B, 1.6);
    ctx.beginPath(); ctx.ellipse(0, -10, 12, 10, 0, 0, Math.PI * 2); ink(ctx, '#e8dcc0', 1.8);
    for (const ex of [-5, 5]) { ctx.beginPath(); ctx.arc(ex, -11, 4, 0, Math.PI * 2); ink(ctx, '#ffcf4a', 1.2); ctx.fillStyle = '#1a120a'; ctx.beginPath(); ctx.arc(ex, -11, 2, 0, Math.PI * 2); ctx.fill(); }
    ctx.fillStyle = '#d89a2a'; ctx.beginPath(); ctx.moveTo(-2, -7); ctx.lineTo(2, -7); ctx.lineTo(0, -3); ctx.closePath(); ctx.fill();
    ctx.restore();
    if (u.team === this.team && arrived) { ctx.save(); ctx.strokeStyle = 'rgba(233,196,106,.22)'; ctx.setLineDash([8, 8]); ctx.lineWidth = 2; ctx.beginPath(); ctx.ellipse(u.x, u.y, 900, 900 * SG.K, 0, 0, Math.PI * 2); ctx.stroke(); ctx.restore(); }
  }
  drawWard(ctx, u) {
    ctx.save(); ctx.translate(u.x, u.y);
    SG.draw.caps(ctx, [[[0, 0], [0, -46], 2.4, '#3a2a20']]);
    ctx.beginPath(); ctx.moveTo(0, -46); ctx.lineTo(-24, -40); ctx.lineTo(0, -30); ctx.closePath(); SG.draw.ink(ctx, '#e9c46a', 1.4);
    ctx.strokeStyle = 'rgba(233,196,106,.25)'; ctx.setLineDash([8, 8]); ctx.beginPath(); ctx.ellipse(0, 0, 420, 150, 0, 0, Math.PI * 2); ctx.stroke();
    ctx.restore();
  }
  drawNums(ctx, dt) {
    const myId = this.me.id;
    for (const e of this.w.dmgEvents) {
      if (e.react) { this.nums.push({ x: e.x, y: e.y - 60, text: e.text, t: 0, col: e.col, size: 22, react: 1 }); continue; }
      if (e.src !== myId && e.tgt !== myId) continue;
      const col = e.heal ? '#8fe08a' : e.tgt === myId ? '#ff7a6a' : '#ffe28a';
      if (e.text) {
        const col2 = e.gold ? '#ffd24a' : e.cc ? '#e7b8ff' : /追擊/.test(e.text) ? '#7fe0ff' : e.text === '連段' ? '#8fe0ff' : '#ffcf6a';
        this.nums.push({ x: e.x, y: e.y - 100, text: e.text, t: 0, col: col2, size: e.gold === 2 ? 26 : e.gold ? 16 : 18 });
        if (e.gold && e.src === myId && SG.Audio) SG.Audio.play('coin', e.x, e.y, this);
        continue;
      }
      this.nums.push({ x: e.x + (Math.random() - 0.5) * 20, y: e.y - 90, v: Math.round(e.v), t: 0, col: e.el && SG.EL && e.tgt !== myId && !e.heal ? SG.EL[e.el].col : col, heal: e.heal });
    }
    this.w.dmgEvents.length = 0;
    this.nums = this.nums.filter((n) => (n.t += dt) < 0.9);
    ctx.save(); ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.lineJoin = 'round';
    for (const n of this.nums) {
      ctx.globalAlpha = n.t > 0.6 ? (0.9 - n.t) / 0.3 : 1;
      if (n.text) {
        const pop = n.react && n.t < 0.12 ? 1.6 - n.t * 5 : 1;
        ctx.font = '900 ' + Math.round((n.size || 18) * pop) + 'px "Noto Serif TC", serif'; const y = n.y - n.t * 30;
        ctx.lineWidth = 4; ctx.strokeStyle = 'rgba(12,14,20,.9)'; ctx.strokeText(n.text, n.x, y); ctx.fillStyle = n.col; ctx.fillText(n.text, n.x, y);
        continue;
      }
      if (n.v < 1) continue;
      // 跳出來時先放大再縮回，重擊（150 以上）更大
      const base = n.v > 300 ? 26 : n.v > 150 ? 20 : 15, pop = n.t < 0.1 ? 1.7 - n.t * 7 : 1;
      ctx.font = '900 ' + Math.round(base * pop) + 'px "IBM Plex Mono", monospace';
      const y = n.y - n.t * 40;
      ctx.lineWidth = 4; ctx.strokeStyle = 'rgba(12,14,20,.9)'; ctx.strokeText((n.heal ? '+' : '') + n.v, n.x, y);
      ctx.fillStyle = n.col; ctx.fillText((n.heal ? '+' : '') + n.v, n.x, y);
    }
    ctx.restore();
  }

  drawMini() {
    const c = this.miniCtx, W = this.mini.width, H = this.mini.height, k = W / M.W;
    if (!this.miniBase) {
      const b = document.createElement('canvas'); b.width = W; b.height = H;
      const x = b.getContext('2d');
      x.fillStyle = '#3e4a2c'; x.fillRect(0, 0, W, H);
      if (M.drawMini) M.drawMini(x, k); // 列傳地圖自己畫底圖
      else {
      x.fillStyle = '#26361f'; for (let yy = 0; yy < M.H; yy += 20) for (let xx = 0; xx < M.W; xx += 20) if (M.forestAt(xx + 10, yy + 10)) x.fillRect(xx * k, yy * k, Math.ceil(20 * k) + 0.5, Math.ceil(20 * k) + 0.5);
      x.strokeStyle = '#8e7750'; x.lineWidth = Math.max(2, 120 * k); x.lineCap = 'round'; x.lineJoin = 'round';
      Object.values(M.lanes).forEach((L) => { x.beginPath(); L.forEach((p, i) => (i ? x.lineTo(p[0] * k, p[1] * k) : x.moveTo(p[0] * k, p[1] * k))); x.stroke(); });
      x.strokeStyle = '#3f6173'; x.lineWidth = Math.max(3, M.river.hw * 2 * k); x.lineCap = 'butt'; x.beginPath(); x.moveTo(M.river.a[0] * k, M.river.a[1] * k); x.lineTo(M.river.b[0] * k, M.river.b[1] * k); x.stroke();
      x.fillStyle = '#6b4a2e'; M.bridges.forEach((b) => x.fillRect(b.x * k - 4, b.y * k - 3, 8, 6));
      x.fillStyle = '#5b6038'; x.beginPath(); x.arc(M.island.x * k, M.island.y * k, M.island.r * k, 0, Math.PI * 2); x.fill();
      x.fillStyle = '#3f6173'; M.shallows.forEach((b) => { x.beginPath(); x.ellipse(b[0] * k, b[1] * k, Math.max(2, b[2] * k), Math.max(1.5, b[3] * k), 0, 0, Math.PI * 2); x.fill(); }); // 淺灘
      }
      this.miniBase = b;
    }
    c.setTransform(1, 0, 0, 1, 0, 0);
    c.drawImage(this.miniBase, 0, 0);
    const sh = this.shroudOf();
    if (sh) { c.globalAlpha = 0.88; c.imageSmoothingEnabled = true; c.drawImage(sh.c, 0, 0, sh.F.cols * sh.F.q * k, sh.F.rows * sh.F.q * k); c.globalAlpha = 1; }
    const dot = (x, y, r, col, ring) => { c.fillStyle = col; c.beginPath(); c.arc(x * k, y * k, r, 0, Math.PI * 2); c.fill(); if (ring) { c.strokeStyle = ring; c.lineWidth = 1.5; c.stroke(); } };
    const d = this.dpr;
    for (const u of this.w.units) {
      if (!u.alive || u.kind === 'ward') continue;
      const r = this.rel(u);
      if (r !== 'ally' && !u.vis[this.team]) continue;
      if (u.structure) { c.fillStyle = COL[r]; const sz = (u.kind === 'base' ? 7 : 5) * d; c.fillRect(u.x * k - sz / 2, u.y * k - sz / 2, sz, sz); c.strokeStyle = '#10141c'; c.lineWidth = 1; c.strokeRect(u.x * k - sz / 2, u.y * k - sz / 2, sz, sz); }
      else if (u.kind === 'hero') dot(u.x, u.y, (u.isPlayer ? 4.2 : 3.4) * d, COL[r], u.isPlayer ? '#ffffff' : '#10141c');
      else if (u.kind === 'boss') dot(u.x, u.y, 4 * d, '#ff5a3a', '#10141c');
      else if (u.kind === 'cart') { c.fillStyle = COL[r]; c.fillRect(u.x * k - 3 * d, u.y * k - 2 * d, 6 * d, 4 * d); c.strokeStyle = '#e8e2d0'; c.lineWidth = 1; c.strokeRect(u.x * k - 3 * d, u.y * k - 2 * d, 6 * d, 4 * d); }
      else dot(u.x, u.y, 1.3 * d, r === 'neutral' ? '#d8a05a' : COL[r]);
    }
    if (this.w.campaign && this.w.campaign.mission && SG.campaignDraw) SG.campaignDraw.mini(c, this, k);
    for (const p of this.pings || []) { // 小地圖上的訊號：閃爍的圓圈
      const d = PINGS[p.k] || PINGS.go, u = p.uid != null ? this.w.units.find((x) => x.id === p.uid && x.alive) : null, x = u ? u.x : p.x, y = u ? u.y : p.y, f = (p.t * 2) % 1;
      c.strokeStyle = d.col; c.lineWidth = 2 * d2(this); c.globalAlpha = 1 - f; c.beginPath(); c.arc(x * k, y * k, (4 + f * 10) * d2(this), 0, Math.PI * 2); c.stroke(); c.globalAlpha = 1;
      c.fillStyle = d.col; c.beginPath(); c.arc(x * k, y * k, 2.5 * d2(this), 0, Math.PI * 2); c.fill();
    }
    const sl = this.w.seal;
    if (sl.state === 'ground') { c.fillStyle = '#7fd1b0'; c.fillRect(sl.x * k - 3.5 * d, sl.y * k - 3.5 * d, 7 * d, 7 * d); }
    else if (sl.state === 'held' && sl.holder.alive) { c.strokeStyle = '#7fd1b0'; c.lineWidth = 2 * d; c.beginPath(); c.arc(sl.holder.x * k, sl.holder.y * k, 6 * d, 0, Math.PI * 2); c.stroke(); }
    const [x0, y0, vw, vh] = this.view;
    c.strokeStyle = 'rgba(255,255,255,.8)'; c.lineWidth = 1 * d; c.strokeRect(x0 * k, y0 * k, vw * k, vh * k);
  }
}
SG.View = View;
